import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import "./translations.css";

const resources = {
    de: {
      translation: {
        "greeting": "Guten Tag,",
        "performance": "Portfolio Performance",
        "regionAllocation": "Regionen Analyse",
        "assetClassAllocation": "Asset Class Verteilung",
        "currencyAllocation": "Währungsanteile",
        'kpi': "KPI's YTD",
        'asset_under_management_mgr': 'Verwaltetes Vermögen',
        'net_new_asset_mgr': 'Netto Neugeld',
        'income_information_mgr': 'Einkommensanalyse',
        'new_clients_mgr': 'Neukunden im Jahr',
        'asset_under_management_adv': 'Verwaltetes Vermögen',
        'net_new_asset_adv': 'Netto Neugeld',
        'income_information_adv': 'Einkommensanalyse',
        'new_clients_adv': 'Neukunden im Jahr',
        'client_contact': 'Kundenkontakt',
        "openAll": "Alle öffnen",
        "closeAll": "Alle schliessen",
        "more": "Mehr",
        "shortSummary": "Quick-Info",
        "longSummary": "Morning Briefing",
        "loadingReadingData": "Deine Finanzdaten werden eingelesen …",
        "loadingAnalyzing": "Kennzahlen werden analysiert …",
        "loadingMerging": "Erkenntnisse werden zusammengeführt …",
        "loadingWriting": "Deine persönliche Story entsteht …",
        "loadingVoicePrep": "Die Stimme wird vorbereitet …",
        "loadingAudioRender": "Dein Audio wird erzeugt …",
        "customer_note": "Kunden Notiz",
        "meeting_minutes": "Meeting Protokoll",
        "meeting_minutes_description": "Starten Sie die Aufnahme, um ein Meeting automatisch zu transkribieren und ein Protokoll zu erstellen. Die KI erkennt Sprecher und fasst die wichtigsten Punkte zusammen.",
        "meeting_minutes_start": "Aufnahme starten",
        "meeting_minutes_stop": "Aufnahme beenden",
        "mm_transcript": "Transkript",
        "mm_rediarizing": "Sprechererkennung wird verbessert...",
        "mm_generating": "Meeting-Protokoll wird erstellt...",
        "mm_topics": "Themen",
        "mm_decisions": "Entscheidungen",
        "mm_action_items": "Massnahmen",
        "mm_connecting": "Verbindung wird hergestellt...",
        "mm_copy": "Kopieren",
        "mm_download": "Herunterladen",
        "mm_download_recording": "Aufnahme herunterladen (WAV)",
        "mm_rediarized": "Sprecherzuordnung verbessert",
        "mm_speakers": "Sprecher",
        "mm_segments": "Segmente",
        "mm_words": "Wörter",
        "mm_processing_transcript": "Transkript wird verfeinert...",
        "mm_processing_minutes": "Protokoll wird erstellt...",
        "mm_history": "Verlauf",
        "mm_no_history": "Noch keine abgeschlossenen Sitzungen.",
        "mm_prev": "Zurück",
        "mm_next": "Weiter",
        'date': 'Datum',
        'client': 'Kunde',
        'type': 'Typ',
        'attendees': 'Teilnehmer',
        'comment': 'Kommentar',
        'save': 'Speichern',
        'chat': 'Assistant Bro',
        'chat_welcome_message': '<h3>Wie kann ich Ihnen heute helfen?</h3><p>Ob Sie einen Überblick über die Leistung Ihrer Portfolios 📊 benötigen, spezifische Details zu einem bestimmten Kundenportfolio 🔍 oder hochwertige Analysteninsights zu einzelnen Anlagepositionen oder Branchen von <b><a href="https://rm.thescreener.com/home/login" target="_blank" class="hover-link">theScreener</a></b> wünschen – ich stehe Ihnen zur Verfügung. Teilen Sie mir einfach mit, welche Informationen Sie benötigen, und ich werde die erforderlichen Daten präzise und effektiv bereitstellen. 🚀</p>',
        'ask_question': 'Frage eingeben...',
        'reset-chat': 'Chat löschen',
        'chat-tab': 'Chat',
        'calendar-tab': 'Mein Kalender',
        'very-important-prompts': 'VIP',
        'load-response': 'Lade Antwort...',
        'open_email': 'E-Mail öffnen',
        'download_visit_report': 'Besuchsbericht herunterladen',
        'load-calendar': 'Lade Kalendereinträge...',
        'description': 'Beschreibung',
        'no-events': 'Keine Kalendereinträge vorhanden.',
        'prepare-me-for-meeting': 'Bereite mich auf meinen Termin vor.',
        'telephone': 'Telefon',
        'on_site': 'Vor Ort',
        'portfolio_performance': 'Portfolio Performance',
        'speak_with_consultant': 'Mit Berater sprechen',
        'help': 'Hilfe',
        'copy_last_response': 'Letzte Antwort kopieren',
        'export_chat_history_to_word': 'Chatverlauf in Word exportieren',
        'minimize_chat': 'Chat verkleinern',
        'maximize_chat': 'Chat vergrössern',
        'close_chat': 'Chat schliessen',
        'speak_with_my_consultant': 'Ich möchte mit meinem Berater sprechen.',
        'breaches': 'Verstösse',
        'to_do': 'Zu erledigen',
        'missing_documents': 'Fehlende Dokumente',
        'strategy': 'Strategie',
        'breach_against_restriction': 'Verstoss gegen Richtlinie',
        'speak_with_earlylion': 'Mit Bro sprechen',
        'select_row_first': 'Bitte zuerst einen Eintrag oben auswählen.',
        'number': 'Nummer',
        'task': 'Aufgabe',
        'portfolio': 'Portfolio',
        'cl_type': 'Kundentyp',
        'document_type': 'Dokument',
        'stocks': 'Aktien',
        'balanced': 'Ausgewogen',
        'income': 'Ertrag',
        'fixed_income': 'Festverzinslich',
        'growth': 'Wachstum',
        'russian_bonds': 'Russische Anleihen',
        'us_stocks': 'US-Aktien',
        'asset_allocation': 'Asset-Allokation',
        'concentration_risk': 'Konzentrationsrisiko',
        'client_meeting_preparation': 'Kundenbesprechungsvorbereitung',
        'send_information': 'Informationen senden',
        'follow_up_client': 'Follow-up mit Kunde',
        'call_back': 'Rückruf',
        'asset_allocation_breach': 'Asset-Allokationsverstoß',
        'aml': 'Geldwäsche',
        'missing': 'Fehlend',
        'expiration': 'Ablauf',
        'form_a': 'Formular A',
        'contract': 'Vertrag',
        'origin_of_wealth': 'Herkunft des Vermögens',
        'passport': 'Pass',
        'document_xy': 'Dokument XY',
        'more_info_about': 'Mehr infos über ...',
        'more_info_about_breaches_from': 'Mehr infos über die Verstösse von ',
        'more_info_about_todos_from': 'Mehr infos über "To Do" für ',
        'more_info_about_missing_documents_from': 'Mehr infos über die fehlenden Dokumente von ',
        'prospect': 'Interessent',
        'tax_residency_declaration': 'Steueransässigkeitserklärung',
        'client_agreement': 'Kundenvereinbarung',
        'proof_of_address': 'Adressnachweis',
        'voice-connecting': 'Verbinde...',
        'voice-listening': 'Zuhören – sprechen Sie jetzt',
        'voice-processing': 'Verarbeite...',
        'voice-speaking': 'Spreche...',
        'voice-setting-up': 'Mikrofon wird eingerichtet...',
        'voice-tap-interrupt': 'Tippen, um zu unterbrechen und erneut zu sprechen',
        'voice-agent': 'KI-Sprachagent',
        'dc-tab-voice': 'Sprachagent',
        'dc-tab-manual': 'Manuelle Eingabe',
        'dc-voice-description': 'Starten Sie den Sprachagenten, um einen Kundenbesuch Schritt für Schritt aufzunehmen. Die KI führt Sie durch alle Felder.',
        'dc-auto-prefill': 'Automatisch aus Kalender vorausfüllen',
        'dc-start-voice': 'Sprachagent starten',
        'dc-start-new': 'Weiteren Besuch erfassen',
        'dc-saved-success': 'Kundenbesuch erfolgreich gespeichert!',
        'dc-confirming': 'Bestätigung...',
        'dc-completed': 'Abgeschlossen!',
        'dc-field': 'Feld',
        'dc-topics': 'Besprochene Themen',
        'dc-feedback': 'Kundenfeedback',
        'dc-decisions': 'Getroffene Entscheidungen',
        'dc-satisfaction': 'Zufriedenheitsbewertung',
        'dc-saving': 'Speichern...',
        'dc-manual-saved': 'Besuch erfolgreich gespeichert.',
        'dc-save-error': 'Besuch konnte nicht gespeichert werden. Bitte versuche es erneut.',
        'dc-tab-all': 'Alle Notizen',
        'dc-filter-client': 'Nach Kunde filtern',
        'dc-all-clients': 'Alle Kunden',
        'dc-no-notes': 'Keine Notizen gefunden.',
        'dc-notes-error': 'Notizen konnten nicht geladen werden.',
        'dc-edit-note': 'Notiz bearbeiten',
        'dc-delete-title': 'Notiz löschen?',
        'dc-delete-body': 'Diese Notiz wird dauerhaft gelöscht.',
        'dc-cancel': 'Abbrechen',
        'dc-delete': 'Löschen',
        'dc-deleted-success': 'Notiz gelöscht.',
        'dc-delete-error': 'Löschen fehlgeschlagen. Bitte erneut versuchen.',
        'dc-updated-success': 'Notiz aktualisiert.',
        'dc-mic-record': 'Diktieren',
        'dc-mic-stop': 'Aufnahme stoppen',
        'dc-client-name': 'Name des Kunden',
        'dc-visit-date': 'Datum des Besuchs',
      }
    },
    fr: {
      translation: {
        "greeting": "Bonjour,",
        "performance": "Performance du Portefeuille",
        "regionAllocation": "Analyse de la Région",
        "assetClassAllocation": "Analyse de la Catégorie d'Actifs",
        "currencyAllocation": "Analyse de la Devise",
        'kpi': "KPI's",
        'asset_under_management_mgr': 'Actifs gérés',
        'net_new_asset_mgr': 'Nouveaux actifs nets',
        'income_information_mgr': 'Analyse des revenus',
        'new_clients_mgr': 'Nouveaux clients',
        'asset_under_management_adv': 'Actifs gérés',
        'net_new_asset_adv': 'Nouveaux actifs nets',
        'income_information_adv': 'Analyse des revenus',
        'new_clients_adv': 'Nouveaux clients',
        'client_contact': 'Contact client',
        "openAll": "Ouvrir tout",
        "closeAll": "Fermer tout",
        "more": "Plus",
        "shortSummary": "Quick-Info",
        "longSummary": "Morning Briefing",
        "loadingReadingData": "Lecture de tes données financières …",
        "loadingAnalyzing": "Analyse des indicateurs clés …",
        "loadingMerging": "Synthèse des informations …",
        "loadingWriting": "Rédaction de ton histoire personnelle …",
        "loadingVoicePrep": "Préparation de la voix …",
        "loadingAudioRender": "Génération de ton audio …",
        "customer_note": "Note client",
        "meeting_minutes": "Procès-verbal",
        "meeting_minutes_description": "Lancez l'enregistrement pour transcrire automatiquement une réunion et générer un procès-verbal. L'IA identifie les intervenants et résume les points clés.",
        "meeting_minutes_start": "Démarrer l'enregistrement",
        "meeting_minutes_stop": "Arrêter l'enregistrement",
        "mm_transcript": "Transcription",
        "mm_rediarizing": "Amélioration de l'identification des locuteurs...",
        "mm_generating": "Génération du procès-verbal...",
        "mm_topics": "Sujets",
        "mm_decisions": "Décisions",
        "mm_action_items": "Actions à suivre",
        "mm_connecting": "Connexion en cours...",
        "mm_copy": "Copier",
        "mm_download": "Télécharger",
        "mm_download_recording": "Télécharger l'enregistrement (WAV)",
        "mm_rediarized": "Identification des locuteurs améliorée",
        "mm_speakers": "Locuteurs",
        "mm_segments": "Segments",
        "mm_words": "Mots",
        "mm_processing_transcript": "Affinage de la transcription...",
        "mm_processing_minutes": "Génération du procès-verbal...",
        "mm_history": "Historique",
        "mm_no_history": "Aucune session terminée pour le moment.",
        "mm_prev": "Précédent",
        "mm_next": "Suivant",
        "date": "Date",
        "client": "Client",
        "type": "Type",
        "attendees": "Participants",
        "comment": "Commentaire",
        "save": "Enregistrer",
        'chat': 'Assistant Bro',
        'chat_welcome_message': "<h3>Comment puis-je vous aider aujourd'hui ?</h3><p>Que vous ayez besoin d'un aperçu des performances de vos portefeuilles 📊, de détails spécifiques sur un portefeuille client particulier 🔍 ou de précieuses analyses d'analystes sur des positions d'investissement individuelles ou des secteurs via <b><a href='https://rm.thescreener.com/home/login' target='_blank' class='hover-link'>theScreener</a></b> – je suis à votre disposition. Dites-moi simplement quelles informations vous nécessitez, et je fournirai les données requises avec précision et efficacité. 🚀</p>",
        'ask_question': 'Entrez une question...',
        'reset-chat': 'Réinitialiser le chat',
        'chat-tab': 'Chat',
        'calendar-tab': 'Mon Calendrier',
        'very-important-prompts': 'VIP',
        'load-response': 'Chargement de la réponse...',
        'open_email': "Ouvrir l'e-mail",
        'download_visit_report': 'Télécharger le rapport de visite',
        'load-calendar': 'Chargement des entrées du calendrier...',
        'description': 'Description',
        'no-events': 'Aucune entrée de calendrier disponible.',
        'prepare-me-for-meeting': 'Prépare-moi pour ma réunion.',
        'telephone': 'Téléphone',
        'on_site': 'Sur place',
        'portfolio_performance': 'Performance du Portefeuille',
        'speak_with_consultant': 'Parler avec un Conseiller',
        'help': 'Aide',
        'copy_last_response': 'Copier la Dernière Réponse',
        'export_chat_history_to_word': "Exporter l'Historique du Chat en Word",
        'minimize_chat': 'Réduire le Chat',
        'maximize_chat': 'Agrandir le Chat',
        'close_chat': 'Fermer le Chat',
        'speak_with_my_consultant': 'Je veux parler avec mon conseiller.',
        'breaches': 'Infractions',
        'to_do': 'À faire',
        'missing_documents': 'Documents manquants',
        'strategy': 'Stratégie',
        'breach_against_restriction': 'Infraction à la restriction',
        'speak_with_earlylion': 'Parler avec Bro',
        'select_row_first': 'Veuillez d’abord sélectionner une entrée ci-dessus.',
        'number': 'Numéro',
        'task': 'Tâche',
        'portfolio': 'Portefeuille',
        'cl_type': 'Type de client',
        'document_type': 'Type de document',
        'stocks': 'Actions',
        'balanced': 'Équilibré',
        'income': 'Revenu',
        'fixed_income': 'À revenu fixe',
        'growth': 'Croissance',
        'russian_bonds': 'Obligations russes',
        'us_stocks': 'Actions américaines',
        'asset_allocation': 'Allocation d’actifs',
        'concentration_risk': 'Risque de concentration',
        'client_meeting_preparation': 'Préparation de la réunion client',
        'send_information': 'Envoyer des informations',
        'follow_up_client': 'Relancer le client',
        'call_back': 'Rappel',
        'asset_allocation_breach': 'Violation de l’allocation d’actifs',
        'aml': 'LBC',
        'missing': 'Manquant',
        'expiration': 'Expiration',
        'form_a': 'Formulaire A',
        'contract': 'Contrat',
        'origin_of_wealth': 'Origine des fonds',
        'passport': 'Passeport',
        'document_xy': 'Document XY',
        "more_info_about": "Plus d'informations sur ...",
        "more_info_about_breaches_from": "Plus d'informations sur les infractions de ",
        "more_info_about_todos_from": "Plus d'informations sur les tâches à faire pour ",
        "more_info_about_missing_documents_from": "Plus d'informations sur les documents manquants de ",
        'prospect': 'Prospect',
        'tax_residency_declaration': 'Déclaration de résidence fiscale',
        'client_agreement': 'Contrat client',
        'proof_of_address': 'Justificatif de domicile',
        'voice-connecting': 'Connexion...',
        'voice-listening': 'Écoute – parlez maintenant',
        'voice-processing': 'Traitement...',
        'voice-speaking': 'Parle...',
        'voice-setting-up': 'Configuration du microphone...',
        'voice-tap-interrupt': 'Appuyez pour interrompre et parler à nouveau',
        'voice-agent': 'Agent Vocal IA',
        'dc-tab-voice': 'Agent Vocal',
        'dc-tab-manual': 'Saisie manuelle',
        'dc-voice-description': 'Lancez l\'agent vocal pour enregistrer une visite client étape par étape.',
        'dc-auto-prefill': 'Pré-remplir automatiquement depuis le calendrier',
        'dc-start-voice': 'Démarrer l\'agent vocal',
        'dc-start-new': 'Enregistrer une autre visite',
        'dc-saved-success': 'Visite client enregistrée avec succès!',
        'dc-confirming': 'Confirmation...',
        'dc-completed': 'Terminé!',
        'dc-field': 'Champ',
        'dc-topics': 'Sujets discutés',
        'dc-feedback': 'Retour client',
        'dc-decisions': 'Décisions prises',
        'dc-satisfaction': 'Note de satisfaction',
        'dc-saving': 'Enregistrement...',
        'dc-manual-saved': 'Visite enregistrée avec succès.',
        'dc-save-error': "La visite n'a pas pu être enregistrée. Veuillez réessayer.",
        'dc-tab-all': 'Toutes les notes',
        'dc-filter-client': 'Filtrer par client',
        'dc-all-clients': 'Tous les clients',
        'dc-no-notes': 'Aucune note trouvée.',
        'dc-notes-error': 'Impossible de charger les notes.',
        'dc-edit-note': 'Modifier la note',
        'dc-delete-title': 'Supprimer la note ?',
        'dc-delete-body': 'Cette note sera définitivement supprimée.',
        'dc-cancel': 'Annuler',
        'dc-delete': 'Supprimer',
        'dc-deleted-success': 'Note supprimée.',
        'dc-delete-error': 'La suppression a échoué. Veuillez réessayer.',
        'dc-updated-success': 'Note mise à jour.',
        'dc-mic-record': 'Dicter',
        'dc-mic-stop': "Arrêter l'enregistrement",
        'dc-client-name': 'Nom du client',
        'dc-visit-date': 'Date de la visite',
      }
    },
    en: {
      translation: {
        "greeting": "Hi,",
        "performance": "Portfolio Performance",
        "regionAllocation": "Region Analysis",
        "assetClassAllocation": "Asset Class Analysis",
        "currencyAllocation": "Currency Analysis",
        'kpi': "KPI's",
        'asset_under_management_mgr': 'Managed Assets',
        'net_new_asset_mgr': 'Net New Assets',
        'income_information_mgr': 'Income Analysis',
        'new_clients_mgr': 'New Clients',
        'asset_under_management_adv': 'Managed Assets',
        'net_new_asset_adv': 'Net New Assets',
        'income_information_adv': 'Income Analysis',
        'new_clients_adv': 'New Clients',
        'client_contact': 'Client Contact',
        "openAll": "Open All",
        "closeAll": "Close All",
        "more": "More",
        "shortSummary": "Quick-Info",
        "longSummary": "Morning Briefing",
        "loadingReadingData": "Reading your financial data …",
        "loadingAnalyzing": "Analysing key figures …",
        "loadingMerging": "Connecting the insights …",
        "loadingWriting": "Writing your personal story …",
        "loadingVoicePrep": "Preparing the voice …",
        "loadingAudioRender": "Generating your audio …",
        "customer_note": "Customer Note",
        "meeting_minutes": "Meeting Minutes",
        "meeting_minutes_description": "Start recording to automatically transcribe a meeting and generate minutes. The AI identifies speakers and summarises the key points.",
        "meeting_minutes_start": "Start Recording",
        "meeting_minutes_stop": "Stop Recording",
        "mm_transcript": "Transcript",
        "mm_rediarizing": "Improving speaker identification...",
        "mm_generating": "Generating meeting minutes...",
        "mm_topics": "Topics",
        "mm_decisions": "Decisions",
        "mm_action_items": "Action Items",
        "mm_connecting": "Connecting...",
        "mm_copy": "Copy",
        "mm_download": "Download",
        "mm_download_recording": "Download recording (WAV)",
        "mm_rediarized": "Speaker identification improved",
        "mm_speakers": "Speakers",
        "mm_segments": "Segments",
        "mm_words": "Words",
        "mm_processing_transcript": "Refining transcript...",
        "mm_processing_minutes": "Generating minutes...",
        "mm_history": "History",
        "mm_no_history": "No completed sessions yet.",
        "mm_prev": "Prev",
        "mm_next": "Next",
        "date": "Date",
        "client": "Client",
        "type": "Type",
        "attendees": "Attendees",
        "comment": "Comment",
        "save": "Save",
        'chat': 'Assistant Bro',
        'chat_welcome_message': "<h3>How can I assist you today?</h3><p>Whether you need an overview of your portfolio's performance 📊, specific details on a particular client portfolio 🔍, or high-quality analyst insights on individual investment positions or sectors from <b><a href='https://rm.thescreener.com/home/login' target='_blank' class='hover-link'>theScreener</a></b> – I am here to help. Just let me know what information you need, and I will provide the necessary data accurately and effectively. 🚀</p>",
        'ask_question': 'Enter a question...',
        'reset-chat': 'Clear chat',
        'chat-tab': 'Chat',
        'calendar-tab': 'My Calendar',
        'very-important-prompts': 'VIP',
        'load-response': 'Loading response...',
        'open_email': 'Open E-Mail',
        'download_visit_report': 'Download visit report',
        'load-calendar': 'Loading calendar entries...',
        'description': 'Description',
        'no-events': 'No calendar entries available.',
        'prepare-me-for-meeting': 'Prepare me for my meeting.',
        'telephone': 'Telephone',
        'on_site': 'On site',
        'portfolio_performance': 'Portfolio Performance',
        'speak_with_consultant': 'Speak with Consultant',
        'help': 'Help',
        'copy_last_response': 'Copy Last Response',
        'export_chat_history_to_word': 'Export Chat History to Word',
        'minimize_chat': 'Minimize Chat',
        'maximize_chat': 'Maximize Chat',
        'close_chat': 'Close Chat',
        'speak_with_my_consultant': 'I want to speak with my consultant.',
        'breaches': 'Breaches',
        'to_do': 'To do',
        'missing_documents': 'Missing documents',
        'strategy': 'Strategy',
        'breach_against_restriction': 'Breach against restriction',
        'speak_with_earlylion': 'Speak with Bro',
        'select_row_first': 'Please select an entry above first.',
        'number': 'Number',
        'task': 'Task',
        'portfolio': 'Portfolio',
        'cl_type': 'Client type',
        'document_type': 'Document type',
        'stocks': 'Stocks',
        'balanced': 'Balanced',
        'income': 'Income',
        'fixed_income': 'Fixed income',
        'growth': 'Growth',
        'russian_bonds': 'Russian bonds',
        'us_stocks': 'US stocks',
        'asset_allocation': 'Asset allocation',
        'concentration_risk': 'Concentration risk',
        'client_meeting_preparation': 'Client Meeting Preparation',
        'send_information': 'Send Information',
        'follow_up_client': 'Follow Up Client',
        'call_back': 'Call back',
        'asset_allocation_breach': 'Asset Allocation Breach',
        'aml': 'AML',
        'missing': 'Missing',
        'expiration': 'Expiration',
        'form_a': 'Form A',
        'contract': 'Contract',
        'origin_of_wealth': 'Origin of Wealth',
        'passport': 'Passport',
        'document_xy': 'Document XY',
        "more_info_about": "More info about ...",
        "more_info_about_breaches_from": "More info about the breaches from ",
        "more_info_about_todos_from": "More info about the 'To Do' for ",
        "more_info_about_missing_documents_from": "More info about the missing documents from ",
        'prospect': 'Prospect',
        'tax_residency_declaration': 'Tax Residency Declaration',
        'client_agreement': 'Client Agreement',
        'proof_of_address': 'Proof of Address',
        'voice-connecting': 'Connecting...',
        'voice-listening': 'Listening – speak now',
        'voice-processing': 'Processing...',
        'voice-speaking': 'Speaking...',
        'voice-setting-up': 'Setting up microphone...',
        'voice-tap-interrupt': 'Tap to interrupt and speak again',
        'voice-agent': 'AI Voice Agent',
        'dc-tab-voice': 'Voice Agent',
        'dc-tab-manual': 'Manual Input',
        'dc-voice-description': 'Start the voice agent to record a customer visit step by step. The AI will guide you through all fields.',
        'dc-auto-prefill': 'Auto-prefill from calendar',
        'dc-start-voice': 'Start Voice Agent',
        'dc-start-new': 'Record Another Visit',
        'dc-saved-success': 'Customer visit saved successfully!',
        'dc-confirming': 'Confirming...',
        'dc-completed': 'Completed!',
        'dc-field': 'Field',
        'dc-topics': 'Topics Discussed',
        'dc-feedback': 'Customer Feedback',
        'dc-decisions': 'Decisions Made',
        'dc-satisfaction': 'Satisfaction Rating',
        'dc-saving': 'Saving...',
        'dc-manual-saved': 'Visit saved successfully.',
        'dc-save-error': 'Could not save the visit. Please try again.',
        'dc-tab-all': 'All Notes',
        'dc-filter-client': 'Filter by client',
        'dc-all-clients': 'All clients',
        'dc-no-notes': 'No notes found.',
        'dc-notes-error': 'Notes could not be loaded.',
        'dc-edit-note': 'Edit note',
        'dc-delete-title': 'Delete note?',
        'dc-delete-body': 'This note will be permanently deleted.',
        'dc-cancel': 'Cancel',
        'dc-delete': 'Delete',
        'dc-deleted-success': 'Note deleted.',
        'dc-delete-error': 'Could not delete the note. Please try again.',
        'dc-updated-success': 'Note updated.',
        'dc-mic-record': 'Dictate',
        'dc-mic-stop': 'Stop recording',
        'dc-client-name': 'Client name',
        'dc-visit-date': 'Date of the visit',
      }
    },
    es: {
      translation: {
          "greeting": "¡Buen día,",
          "performance": "Rendimiento del Portafolio",
          "regionAllocation": "Análisis de Regiones",
          "assetClassAllocation": "Distribución de Clase de Activos",
          "currencyAllocation": "Distribución de Monedas",
          'kpi': "KPI's YTD",
          'asset_under_management_mgr': 'Activos Bajo Gestión',
          'net_new_asset_mgr': 'Nuevos Activos Netos',
          'income_information_mgr': 'Análisis de Ingresos',
          'new_clients_mgr': 'Nuevos Clientes en el Año',
          'asset_under_management_adv': 'Activos Bajo Gestión',
          'net_new_asset_adv': 'Nuevos Activos Netos',
          'income_information_adv': 'Análisis de Ingresos',
          'new_clients_adv': 'Nuevos Clientes en el Año',
          'client_contact': 'Contacto con el Cliente',
          "openAll": "Abrir todo",
          "closeAll": "Cerrar todo",
          "more": "Más",
          "shortSummary": "Quick-Info",
          "longSummary": "Morning Briefing",
          "loadingReadingData": "Leyendo tus datos financieros …",
          "loadingAnalyzing": "Analizando los indicadores clave …",
          "loadingMerging": "Conectando la información …",
          "loadingWriting": "Redactando tu historia personal …",
          "loadingVoicePrep": "Preparando la voz …",
          "loadingAudioRender": "Generando tu audio …",
          "customer_note": "Nota del Cliente",
          "meeting_minutes": "Acta de Reunión",
          "meeting_minutes_description": "Inicie la grabación para transcribir automáticamente una reunión y generar un acta. La IA identifica a los participantes y resume los puntos clave.",
          "meeting_minutes_start": "Iniciar grabación",
          "meeting_minutes_stop": "Detener grabación",
          "mm_transcript": "Transcripción",
          "mm_rediarizing": "Mejorando la identificación de hablantes...",
          "mm_generating": "Generando acta de reunión...",
          "mm_topics": "Temas",
          "mm_decisions": "Decisiones",
          "mm_action_items": "Acciones a seguir",
          "mm_connecting": "Conectando...",
          "mm_copy": "Copiar",
          "mm_download": "Descargar",
          "mm_download_recording": "Descargar grabación (WAV)",
          "mm_rediarized": "Identificación de hablantes mejorada",
          "mm_speakers": "Hablantes",
          "mm_segments": "Segmentos",
          "mm_words": "Palabras",
          "mm_processing_transcript": "Refinando transcripción...",
          "mm_processing_minutes": "Generando acta...",
          "mm_history": "Historial",
          "mm_no_history": "Aún no hay sesiones completadas.",
          "mm_prev": "Anterior",
          "mm_next": "Siguiente",
          'date': 'Fecha',
          'client': 'Cliente',
          'type': 'Tipo',
          'attendees': 'Asistentes',
          'comment': 'Comentario',
          'save': 'Guardar',
          'chat': 'Assistant Bro',
          'chat_welcome_message': '<h3>¿Cómo puedo ayudarle hoy?</h3><p>Ya sea que necesite un resumen del rendimiento de sus carteras 📊, detalles específicos sobre un portfolio de cliente específico 🔍, o insights analíticos de calidad sobre posiciones de inversión individuales o sectores a través de <b><a href="https://rm.thescreener.com/home/login" target="_blank" class="hover-link">theScreener</a></b> – estoy a su disposición. Simplemente indíqueme qué información requiere y proporcionaré los datos necesarios de manera precisa y efectiva. 🚀</p>',
          'ask_question': 'Ingresar pregunta...',
          'reset-chat': 'Eliminar chat',
          'chat-tab': 'Chat',
          'calendar-tab': 'Mi Calendario',
          'very-important-prompts': 'VIP',
          'load-response': 'Cargando respuesta...',
          'open_email': 'Abrir correo',
          'download_visit_report': 'Descargar informe de visita',
          'load-calendar': 'Cargando entradas del calendario...',
          'description': 'Descripción',
          'no-events': 'No hay entradas de calendario disponibles.',
          'prepare-me-for-meeting': 'Prepárame para mi reunión.',
          'telephone': 'Teléfono',
          'on_site': 'En el sitio',
          'portfolio_performance': 'Rendimiento del Portafolio',
          'speak_with_consultant': 'Hablar con un Asesor',
          'help': 'Ayuda',
          'copy_last_response': 'Copiar Última Respuesta',
          'export_chat_history_to_word': 'Exportar Historial del Chat a Word',
          'minimize_chat': 'Minimizar Chat',
          'maximize_chat': 'Maximizar Chat',
          'close_chat': 'Cerrar Chat',
          'speak_with_my_consultant': 'Quiero hablar con mi asesor.',
          'breaches': 'Infracciones',
          'to_do': 'Por hacer',
          'missing_documents': 'Documentos faltantes',
          'strategy': 'Estrategia',
          'breach_against_restriction': 'Infracción contra restricción',
          'speak_with_earlylion': 'Hablar con Bro',
          'select_row_first': 'Por favor, seleccione primero una entrada arriba.',
          'number': 'Número',
          'task': 'Tarea',
          'portfolio': 'Portafolio',
          'cl_type': 'Tipo de cliente',
          'document_type': 'Tipo de documento',
          'stocks': 'Acciones',
          'balanced': 'Equilibrado',
          'income': 'Ingresos',
          'fixed_income': 'Renta fija',
          'growth': 'Crecimiento',
          'russian_bonds': 'Bonos rusos',
          'us_stocks': 'Acciones estadounidenses',
          'asset_allocation': 'Asignación de activos',
          'concentration_risk': 'Riesgo de concentración',
          'client_meeting_preparation': 'Preparación de reunión con cliente',
          'send_information': 'Enviar información',
          'follow_up_client': 'Seguimiento al cliente',
          'call_back': 'Devolver la llamada',
          'asset_allocation_breach': 'Incumplimiento de asignación de activos',
          'aml': 'Prevención de lavado de dinero',
          'missing': 'Faltante',
          'expiration': 'Vencimiento',
          'form_a': 'Formulario A',
          'contract': 'Contrato',
          'origin_of_wealth': 'Origen del patrimonio',
          'passport': 'Pasaporte',
          'document_xy': 'Documento XY',
          "more_info_about": "Más información sobre ...",
          "more_info_about_breaches_from": "Más información sobre las infracciones de ",
          "more_info_about_todos_from": "Más información sobre las tareas pendientes de ",
          "more_info_about_missing_documents_from": "Más información sobre los documentos faltantes de ",
          'prospect': 'Prospecto',
          'tax_residency_declaration': 'Declaración de residencia fiscal',
          'client_agreement': 'Acuerdo con el cliente',
          'proof_of_address': 'Comprobante de domicilio',
          'voice-connecting': 'Conectando...',
          'voice-listening': 'Escuchando – hable ahora',
          'voice-processing': 'Procesando...',
          'voice-speaking': 'Hablando...',
          'voice-setting-up': 'Configurando micrófono...',
          'voice-tap-interrupt': 'Toque para interrumpir y hablar nuevamente',
          'voice-agent': 'Agente de Voz IA',
          'dc-tab-voice': 'Agente de Voz',
          'dc-tab-manual': 'Entrada manual',
          'dc-voice-description': 'Inicie el agente de voz para registrar una visita de cliente paso a paso.',
          'dc-auto-prefill': 'Rellenar automáticamente desde el calendario',
          'dc-start-voice': 'Iniciar Agente de Voz',
          'dc-start-new': 'Registrar otra visita',
          'dc-saved-success': '¡Visita guardada con éxito!',
          'dc-confirming': 'Confirmando...',
          'dc-completed': '¡Completado!',
          'dc-field': 'Campo',
          'dc-topics': 'Temas discutidos',
          'dc-feedback': 'Comentarios del cliente',
          'dc-decisions': 'Decisiones tomadas',
          'dc-satisfaction': 'Calificación de satisfacción',
          'dc-saving': 'Guardando...',
          'dc-manual-saved': 'Visita guardada con éxito.',
          'dc-save-error': 'No se pudo guardar la visita. Inténtalo de nuevo.',
          'dc-tab-all': 'Todas las notas',
          'dc-filter-client': 'Filtrar por cliente',
          'dc-all-clients': 'Todos los clientes',
          'dc-no-notes': 'No se encontraron notas.',
          'dc-notes-error': 'No se pudieron cargar las notas.',
          'dc-edit-note': 'Editar nota',
          'dc-delete-title': '¿Eliminar nota?',
          'dc-delete-body': 'Esta nota se eliminará permanentemente.',
          'dc-cancel': 'Cancelar',
          'dc-delete': 'Eliminar',
          'dc-deleted-success': 'Nota eliminada.',
          'dc-delete-error': 'No se pudo eliminar la nota. Inténtalo de nuevo.',
          'dc-updated-success': 'Nota actualizada.',
          'dc-mic-record': 'Dictar',
          'dc-mic-stop': 'Detener grabación',
          'dc-client-name': 'Nombre del cliente',
          'dc-visit-date': 'Fecha de la visita',
      },
    },
    it: {
      translation: {
        "greeting": "Buongiorno,",
        "performance": "Performance del Portfolio",
        "regionAllocation": "Analisi Regionale",
        "assetClassAllocation": "Distribuzione per Classe di Asset",
        "currencyAllocation": "Composizione Valutaria",
        'kpi': "KPI's YTD",
        'asset_under_management_mgr': 'Patrimonio Gestito',
        'net_new_asset_mgr': 'Nuovi Patrimoni Netto',
        'income_information_mgr': 'Analisi dei Redditi',
        'new_clients_mgr': "Nuovi Clienti nell'Anno",
        'asset_under_management_adv': 'Patrimonio Gestito',
        'net_new_asset_adv': 'Nuovi Patrimoni Netto',
        'income_information_adv': 'Analisi dei Redditi',
        'new_clients_adv': "Nuovi Clienti nell'Anno",
        'client_contact': 'Contatto Cliente',
        "openAll": "Apri Tutto",
        "closeAll": "Chiudi Tutto",
        "more": "Altro",
        "shortSummary": "Quick-Info",
        "longSummary": "Morning Briefing",
        "loadingReadingData": "Lettura dei tuoi dati finanziari …",
        "loadingAnalyzing": "Analisi degli indicatori chiave …",
        "loadingMerging": "Sintesi delle informazioni …",
        "loadingWriting": "Sto scrivendo la tua storia personale …",
        "loadingVoicePrep": "Preparazione della voce …",
        "loadingAudioRender": "Generazione del tuo audio …",
        "customer_note": "Nota del Cliente",
        "meeting_minutes": "Verbale di Riunione",
        "meeting_minutes_description": "Avvia la registrazione per trascrivere automaticamente una riunione e generare il verbale. L'IA identifica i relatori e riassume i punti chiave.",
        "meeting_minutes_start": "Avvia registrazione",
        "meeting_minutes_stop": "Ferma registrazione",
        "mm_transcript": "Trascrizione",
        "mm_rediarizing": "Miglioramento dell'identificazione dei parlanti...",
        "mm_generating": "Generazione del verbale...",
        "mm_topics": "Argomenti",
        "mm_decisions": "Decisioni",
        "mm_action_items": "Azioni da intraprendere",
        "mm_connecting": "Connessione in corso...",
        "mm_copy": "Copia",
        "mm_download": "Scarica",
        "mm_download_recording": "Scarica registrazione (WAV)",
        "mm_rediarized": "Identificazione dei parlanti migliorata",
        "mm_speakers": "Parlanti",
        "mm_segments": "Segmenti",
        "mm_words": "Parole",
        "mm_processing_transcript": "Perfezionamento della trascrizione...",
        "mm_processing_minutes": "Generazione del verbale...",
        "mm_history": "Cronologia",
        "mm_no_history": "Nessuna sessione completata finora.",
        "mm_prev": "Indietro",
        "mm_next": "Avanti",
        'date': 'Data',
        'client': 'Cliente',
        'type': 'Tipo',
        'attendees': 'Partecipanti',
        'comment': 'Commento',
        'save': 'Salva',
        'chat': 'Assistant Bro',
        'chat_welcome_message': '<h3>Come posso aiutarti oggi?</h3><p>Se hai bisogno di una panoramica sulla performance dei tuoi portafogli 📊, dettagli specifici su un particolare portafoglio cliente 🔍 o informazioni di analisi di qualità su singole posizioni di investimento o settori da <b><a href="https://rm.thescreener.com/home/login" target="_blank" class="hover-link">theScreener</a></b> – sono a tua disposizione. Dicci semplicemente quali informazioni ti servono e fornirò i dati necessari in modo preciso ed efficace. 🚀</p>',
        'ask_question': 'Inserisci una domanda...',
        'reset-chat': 'Cancella chat',
        'chat-tab': 'Chat',
        'calendar-tab': 'Il mio calendario',
        'very-important-prompts': 'VIP',
        'load-response': 'Carico risposta...',
        'open_email': 'Apri e-mail',
        'download_visit_report': 'Scarica il rapporto di visita',
        'load-calendar': 'Caricamento appuntamenti del calendario...',
        'description': 'Descrizione',
        'no-events': 'Nessun evento in calendario.',
        'prepare-me-for-meeting': 'Preparami per il mio appuntamento.',
        'telephone': 'Telefono',
        'on_site': 'Sul posto',
        'portfolio_performance': 'Rendimento del Portafoglio',
        'speak_with_consultant': 'Parla con un Consulente',
        'help': 'Aiuto',
        'copy_last_response': "Copia l'Ultima Risposta",
        'export_chat_history_to_word': 'Esporta la Cronologia della Chat in Word',
        'minimize_chat': 'Riduci Chat',
        'maximize_chat': 'Ingrandisci Chat',
        'close_chat': 'Chiudi Chat',
        'speak_with_my_consultant': 'Voglio parlare con il mio consulente.',
        'breaches': 'Violazioni',
        'to_do': 'Da fare',
        'missing_documents': 'Documenti mancanti',
        'strategy': 'Strategia',
        'breach_against_restriction': 'Violazione della restrizione',
        'speak_with_earlylion': 'Parlare con Bro',
        'select_row_first': 'Seleziona prima una voce qui sopra.',
        'number': 'Numero',
        'task': 'Compito',
        'portfolio': 'Portafoglio',
        'cl_type': 'Tipo di cliente',
        'document_type': 'Tipo di documento',
        'stocks': 'Azioni',
        'balanced': 'Bilanciato',
        'income': 'Reddito',
        'fixed_income': 'Reddito fisso',
        'growth': 'Crescita',
        'russian_bonds': 'Obbligazioni russe',
        'us_stocks': 'Azioni statunitensi',
        'asset_allocation': 'Allocazione degli attivi',
        'concentration_risk': 'Rischio di concentrazione',
        'client_meeting_preparation': 'Preparazione incontro cliente',
        'send_information': 'Inviare informazioni',
        'follow_up_client': 'Seguire il cliente',
        'call_back': 'Richiamare',
        'asset_allocation_breach': 'Violazione allocazione attività',
        'aml': 'Antiriciclaggio',
        'missing': 'Mancante',
        'expiration': 'Scadenza',
        'form_a': 'Modulo A',
        'contract': 'Contratto',
        'origin_of_wealth': 'Origine del patrimonio',
        'passport': 'Passaporto',
        'document_xy': 'Documento XY',
        "more_info_about": "Ulteriori informazioni su ...",
        "more_info_about_breaches_from": "Ulteriori informazioni sulle violazioni di ",
        "more_info_about_todos_from": "Ulteriori informazioni sulle attività da fare per ",
        "more_info_about_missing_documents_from": "Ulteriori informazioni sui documenti mancanti di ",
        'prospect': 'Prospetto',
        'tax_residency_declaration': 'Dichiarazione di residenza fiscale',
        'client_agreement': 'Accordo con il cliente',
        'proof_of_address': 'Prova di residenza',
        'voice-connecting': 'Connessione...',
        'voice-listening': 'Ascolto – parla ora',
        'voice-processing': 'Elaborazione...',
        'voice-speaking': 'Parlando...',
        'voice-setting-up': 'Configurazione del microfono...',
        'voice-tap-interrupt': 'Tocca per interrompere e parlare di nuovo',
        'voice-agent': 'Agente Vocale IA',
        'dc-tab-voice': 'Agente Vocale',
        'dc-tab-manual': 'Inserimento manuale',
        'dc-voice-description': 'Avvia l\'agente vocale per registrare una visita cliente passo dopo passo.',
        'dc-auto-prefill': 'Precompilazione automatica dal calendario',
        'dc-start-voice': 'Avvia Agente Vocale',
        'dc-start-new': 'Registra un\'altra visita',
        'dc-saved-success': 'Visita cliente salvata con successo!',
        'dc-confirming': 'Conferma...',
        'dc-completed': 'Completato!',
        'dc-field': 'Campo',
        'dc-topics': 'Argomenti discussi',
        'dc-feedback': 'Feedback del cliente',
        'dc-decisions': 'Decisioni prese',
        'dc-satisfaction': 'Valutazione soddisfazione',
        'dc-saving': 'Salvataggio...',
        'dc-manual-saved': 'Visita salvata con successo.',
        'dc-save-error': 'Impossibile salvare la visita. Riprova.',
        'dc-tab-all': 'Tutte le note',
        'dc-filter-client': 'Filtra per cliente',
        'dc-all-clients': 'Tutti i clienti',
        'dc-no-notes': 'Nessuna nota trovata.',
        'dc-notes-error': 'Impossibile caricare le note.',
        'dc-edit-note': 'Modifica nota',
        'dc-delete-title': 'Eliminare la nota?',
        'dc-delete-body': 'Questa nota verrà eliminata definitivamente.',
        'dc-cancel': 'Annulla',
        'dc-delete': 'Elimina',
        'dc-deleted-success': 'Nota eliminata.',
        'dc-delete-error': 'Eliminazione non riuscita. Riprova.',
        'dc-updated-success': 'Nota aggiornata.',
        'dc-mic-record': 'Detta',
        'dc-mic-stop': 'Interrompi registrazione',
        'dc-client-name': 'Nome del cliente',
        'dc-visit-date': 'Data della visita',
      }
    }
};

// ── Advisor Reasoning Engine keys (merged into the per-language resources) ──
const areTranslations = {
  de: {
    advisor_reasoning: "Advisor Reasoning Engine",
    advisor_reasoning_description: "Begründen Sie Kauf-, Halte- oder Verkaufsentscheidungen mit recherchierten Fakten.",
    efd_agent: "Assistant Bro EFD",
    efd_agent_description: "Fragen zu Vermögen, Kunden, Neugeldern und Erträgen — beantwortet direkt aus der EFD-Datenbank.",
    efd_agent_intro: "Stellen Sie eine Frage zu den Bankdaten, z.B. „Wie viel verwaltetes Vermögen haben wir aktuell?“ oder „Wie entwickeln sich die Netto-Neugelder dieses Jahr?“",
    efd_agent_placeholder: "Frage zu den Bankdaten stellen …",
    ppi_agent: "Assistant Bro PPI",
    ppi_agent_intro: "Stell eine Frage zu den Portfolios, z.B. „Wie ist das Vermögen nach Anlageklassen verteilt?“ oder „Wie hat die Performance seit Jahresbeginn ausgesehen?“",
    ppi_agent_placeholder: "Frage zu den Portfoliodaten stellen …",
    efd_survista_agent: "Assistant Bro EFD",
    efd_survista_agent_intro: "Stell eine Frage zu den survista-Kunden, z.B. „Wie verteilt sich das Vermögen auf die Kunden?“ oder „Wie viel Netto-Neugeld hatten wir seit Jahresbeginn?“",
    efd_survista_agent_placeholder: "Frage zu den survista-Zahlen stellen …",
    efd_agent_error: "Die Anfrage ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    efd_email_draft_summary: "E-Mail-Entwurf an {{name}}: {{subject}}",
    efd_attachment_summary: "Dokument bereitgestellt: {{title}}",
    efd_attachment_open: "Öffnen",
    chart_as_of: "Stand: {{date}}",
    chart_show_chart: "Als Grafik anzeigen",
    chart_show_table: "Als Tabelle anzeigen",
    chart_building: "Grafik wird erstellt",
    graphs_tab: "Graphs",
    graphs_create_deck: "PowerPoint erstellen",
    graphs_selected: "{{count}} ausgewählt",
    graphs_select_hint: "Grafiken für die Präsentation anhaken",
    graphs_deck_error: "Die Präsentation konnte nicht erstellt werden.",
    graphs_empty: "Noch keine Grafiken gespeichert. Markiere eine Grafik im Chat mit dem Stern.",
    graphs_saved_on: "gespeichert {{date}}",
    graphs_show: "Grafik anzeigen",
    graphs_hide: "Grafik ausblenden",
    graphs_ask_again: "Mit aktuellen Zahlen erneut fragen",
    graphs_delete: "Grafik löschen",
    graphs_delete_title: "Grafik löschen?",
    graphs_star_add: "In Graphs speichern",
    graphs_star_remove: "Aus Graphs entfernen",
    graphs_select_all: "Alle auswählen",
    graphs_delete_selected: "Ausgewählte löschen",
    graphs_delete_many_title: "{{count}} Grafiken löschen?",
    graphs_view_chart: "Grafik",
    graphs_view_table: "Tabelle",
    graphs_view_both: "Grafik + Tabelle",
    graphs_all: "Alle",
    graphs_groups: "Gruppen",
    graphs_group_new: "Neue Gruppe",
    graphs_group_name: "Name der Gruppe",
    graphs_group_exists: "Diese Gruppe gibt es schon.",
    graphs_group_error: "Das hat nicht geklappt. Bitte nochmal versuchen.",
    graphs_group_menu: "Gruppe bearbeiten",
    graphs_group_rename: "Umbenennen",
    graphs_group_delete: "Gruppe löschen",
    graphs_group_delete_title: "Gruppe „{{name}}“ löschen?",
    graphs_group_delete_text: "Die Grafiken bleiben unter „Alle“ gespeichert.",
    graphs_group_empty: "Diese Gruppe ist noch leer.",
    graphs_group_add_graphs: "Grafiken hinzufügen",
    graphs_group_add_title: "Grafiken zu „{{name}}“ hinzufügen",
    graphs_group_add_none: "Alle Grafiken sind schon in dieser Gruppe.",
    graphs_group_add_confirm: "Hinzufügen",
    graphs_group_deck: "PowerPoint der Gruppe",
    graphs_group_hint: "Ziehe die Grafiken in die Reihenfolge der Präsentation.",
    graphs_groups_of: "Gruppen zuordnen",
    graphs_add_to_group: "Zu Gruppe",
    graphs_add_to_group_title: "Ausgewählte zu Gruppe hinzufügen ({{count}})",
    graphs_remove_from_group: "Aus Gruppe entfernen",
    graphs_drag: "Ziehen, um die Reihenfolge zu ändern",
    graphs_added_to_group: "Zu „{{name}}“ hinzugefügt",
    graphs_removed_from_group: "Aus „{{name}}“ entfernt",
    graphs_group_created: "Gruppe „{{name}}“ erstellt",
    graphs_undo: "Rückgängig",
    graphs_open_group: "Öffnen",
    graphs_in_groups: "in Gruppen: {{names}}",
    graphs_deck_dark: "Dunkle Folien · klicken für helle",
    graphs_deck_light: "Helle Folien · klicken für dunkle",
    graphs_deck_theme_dark: "dunkle Folien",
    graphs_deck_theme_light: "helle Folien",
    attachment_open_pdf: "PDF öffnen",
    attachment_open_presentation: "Präsentation öffnen",
    attachment_open_document: "Bericht öffnen",
    attachment_open_email: "E-Mail öffnen",
    ts_title_stock: "theScreener-Report — {{name}}",
    ts_title_sector: "theScreener-Sektor-Report — {{name}}",
    ts_title_industry_group: "theScreener-Branchengruppe-Report — {{name}}",
    ts_title_index: "theScreener-Index-Report — {{name}}",
    ts_variant_complete: "Komplettreport",
    ts_variant_short: "Kurzreport",
    ts_data_as_of: "Datenstand {{date}}",
    ts_scope_sector: "Sektor",
    ts_scope_industry_group: "Branchengruppe",
    ts_scope_index: "Index",
    ts_worldwide: "weltweit",
    artifact_ready_powerpoint: "Präsentation bereit",
    artifact_ready_pdf: "PDF bereit",
    artifact_ready_document: "Kundenbericht bereit",
    artifact_ready_email: "E-Mail vorbereitet",
    artifact_ready_link: "Link bereit",
    artifact_ready: "Bereit",
    efd_agent_stage_connecting: "Verbindung zur EFD-Datenbank",
    efd_agent_stage_querying: "Aktuelle Kennzahlen werden geladen",
    efd_agent_stage_composing: "Ihre Übersicht wird aufbereitet",
    efd_agent_welcome_error: "Die Übersicht konnte nicht geladen werden — stellen Sie einfach direkt Ihre Frage.",
    efd_voice_tooltip: "Sprachgespräch starten",
    efd_voice_mic_setup: "Mikrofon wird vorbereitet …",
    efd_voice_listening: "Ich höre …",
    efd_voice_processing: "Einen Moment, ich schaue nach …",
    efd_voice_interrupt: "Tippen zum Unterbrechen",
    efd_voice_error: "Es gab ein Problem mit der Sprachverbindung.",
    efd_voice_mic_denied: "Kein Zugriff auf das Mikrofon. Bitte Berechtigung prüfen.",
    efd_vip_add: "Prompt hinzufügen",
    efd_vip_add_title: "Prompt speichern",
    efd_vip_edit_title: "Prompt bearbeiten",
    efd_vip_delete_title: "Prompt löschen?",
    efd_vip_empty: "Noch keine gespeicherten Prompts. Speichern Sie häufige Fragen mit dem Stern-Symbol.",
    efd_vip_save: "Als Prompt speichern",
    are_tab_assistant: "Assistent", are_tab_runs: "Analysen",
    // ── Not Controlled Chat (third ARE tab) — a plain ChatGPT-style chat.
    //    The tab label is a product name and stays untranslated.
    are_tab_free: "Not Controlled Chat",
    are_free_welcome: "Hallo! Das hier ist ein freier Chat — ohne die Vorgaben der Advisor Reasoning Engine, dafür mit Zugriff auf die Websuche. Frag mich, was du willst.",
    are_free_placeholder: "Frag mich irgendetwas …",
    are_free_searching: "Suche im Web …",
    are_free_stop: "Stoppen",
    are_free_stopped: "Abgebrochen.",
    are_free_empty: "Es kam keine Antwort zurück. Bitte erneut versuchen.",
    are_free_disclaimer: "Freier Chat ohne fachliche Vorgaben — KI-Antworten können falsch sein. Keine Anlageberatung.",
    // Spoken entry line for the Not Controlled Chat's voice mode. Kept short
    //   and free of markup — it goes straight to text-to-speech.
    are_free_voice_greeting: "Hallo! Frag mich einfach, was du wissen willst — ich kann bei Bedarf auch im Netz nachsehen.",
    session_expired: "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.",
    are_assistant_welcome: "Hallo! Welches Wertpapier möchtest du analysieren? Nenn mir Firmenname und Ticker (z. B. Tesla, TSLA), optional auch deine Tendenz (kaufen/halten/verkaufen). Du kannst mich auch fragen, welche Analysen du schon hast, oder sie miteinander vergleichen lassen.",
    are_disclaimer: "Die Informationen wurden von KI generiert und stellen eine Analyse der Informationen dar, keine Empfehlung.",
    are_translating: "Diese Analyse wurde in einer anderen Sprache erstellt und wird gerade übersetzt …",
    are_assistant_placeholder: "Z. B. „Analysiere Tesla“ oder „Vergleiche BYD mit BMW“…",
    are_new_chat: "Neue Unterhaltung",
    are_duplicate: "Duplizieren", are_duplicate_intro: "Ich möchte diese Analyse duplizieren:",
    are_started_hint: "Die Analyse wurde gestartet. Du findest sie im Tab „Analysen“.",
    are_error: "Es ist ein Fehler aufgetreten. Bitte erneut versuchen.",
    are_runs_hint: "Deine bisherigen Analysen", are_runs_empty: "Noch keine Analysen. Starte eine über den Assistenten.",
    are_run_start: "Analyse starten", are_run_not_started: "Diese Analyse wurde noch nicht ausgeführt.",
    are_no_evidence: "Für den gewählten Zeitraum wurden keine Informationen gefunden.", are_period: "Zeitraum", are_last_updated: "Letzte Aktualisierung",
    are_cat_narratives: "Dominante Narrative", are_cat_positive: "Positive Entwicklungen", are_cat_negative: "Negative Entwicklungen",
    are_cat_turning: "Wendepunkte", are_cat_uncertainties: "Unsicherheiten",
    are_section_risk: "Risikoentwicklung", are_section_perception: "Marktwahrnehmung", are_section_stability: "Stabilität der Narrative",
    are_section_news: "Nachrichtenlage", are_section_conflicts: "Widersprüchliche Datenlage",
    are_overall_constructive: "Eher konstruktiv", are_overall_neutral: "Neutral", are_overall_cautious: "Vorsichtig",
    are_bericht: "Briefing", are_bericht_generating: "Briefing wird erstellt…", are_bericht_updating: "Briefing wird aktualisiert…", are_bericht_regenerate: "Briefing neu erstellen", are_prog_bericht: "Briefing wird erstellt…",
    are_more_details: "Mehr Details", are_more_details_sub: "Themen & Quellen ansehen und bearbeiten", are_details_themen: "Themen",
    are_position_choose: "Für welche Entscheidung suchst du Insights?", are_position_pick_hint: "Wähle oben eine Entscheidung, um eine Begründung zu erstellen.", are_position_verdict_for: "Begründung für", are_requested_leaning: "Vorgegebene Tendenz", are_screener_on: "Mit TheScreener", are_screener_off: "Ohne TheScreener", are_weeks_short: "Wochen",
    are_deepen: "Vertiefen", are_deepen_result: "Vertiefung", are_new_developments: "Neue Entwicklungen", are_open_questions: "Offene Fragen",
    are_takeaways_title: "Kernaussagen", are_details_title: "Details", are_modal_title: "Narrative & Themen", are_modal_entry_sub: "Alle Narrative ansehen & verwalten", are_modal_count: "Narrative", are_modal_detail_title: "Narrativ-Details", are_modal_gone: "Dieses Narrativ wurde gelöscht.", are_modal_empty: "Noch keine Analyse-Inhalte vorhanden.", are_modal_cat_empty: "In dieser Kategorie gibt es noch keine Narrative.", are_more_analysis: "Weitere Analyse", are_back_overview: "Zurück zur Analyse", are_narr_add: "Hinzufügen", are_narr_add_placeholder: "Neues Narrativ formulieren …", are_narr_edit: "Bearbeiten", are_narr_delete: "Löschen", are_narr_delete_confirm: "Dieses Narrativ wirklich löschen?", are_narr_advisor: "Berater", are_deepen_focus_placeholder: "Optionaler Fokus (z. B. Lieferkette, Margen) …", are_deepen_focus_label: "Fokus",
    are_sources: "Quellen", are_positioning_question: "Entscheidung begründen:", are_buy: "Kaufen", are_hold: "Halten", are_sell: "Verkaufen", are_switch_position: "Andere Position prüfen:", are_refresh_arg: "Neu laden", are_no_arg_yet: "Für diese Position wurde noch keine Begründung erstellt.", are_generate_arg: "Begründung erstellen", are_tag_hint: "Tippe auf ein Narrativ, um es unten in den Details zu öffnen",
    are_verdict_A: "überwiegend gestützt", are_verdict_B: "teilweise gestützt", are_verdict_C: "nicht ausreichend gestützt",
    are_evidence_quality: "Evidenzqualität", are_supporting: "Dafür sprechende Narrative", are_contradicting: "Dagegen sprechende Narrative",
    are_risks_against: "Risiken gegen die These",
    are_status_planning: "Planung", are_status_planned: "Geplant", are_status_collecting: "Sammelt", are_status_collected: "Gesammelt",
    are_status_analyzing: "Analysiert", are_status_ready: "Fertig", are_status_error: "Fehler",
    are_prog_started: "Wird gestartet…", are_prog_screener: "TheScreener-Daten werden geladen…", are_prog_search: "Suche",
    are_prog_analyzing: "Analyse wird erstellt…", are_prog_collected: "Informationen gesammelt…", are_prog_working: "Bitte warten…", are_prog_argument: "Entscheidung wird begründet…",
    are_hero_researching: "Market Intelligence wird aufgebaut…", are_hero_analyzing: "Analyse wird erstellt…",
    are_hero_subtitle: "Quellen werden durchsucht und chronologisch ausgewertet", are_step_screener: "TheScreener-Daten",
    // Progress status of the screener step when the title is not covered by
    //   theScreener (the run continues without it). Shown after the step label.
    are_step_not_found: "nicht gefunden",
    // Same step when theScreener could not be asked (outage, not configured,
    //   data still loading) — not a statement about the title's coverage.
    are_step_unavailable: "derzeit nicht verfügbar",
    are_delete: "Löschen", are_delete_confirm: "Diese Analyse wirklich löschen? Das kann nicht rückgängig gemacht werden.", are_delete_title: "Analyse löschen", are_cancel: "Abbrechen", are_loading: "Analyse wird geladen…",
    are_voice_tooltip: "Sprechen", are_voice_processing: "Einen Moment…", are_voice_mic_setup: "Mikrofon wird vorbereitet…",
    are_voice_listening: "Ich höre…", are_voice_mic_denied: "Mikrofonzugriff verweigert", are_voice_interrupt: "Zum Unterbrechen tippen",
    are_voice_you: "Du", are_voice_assistant: "Assistent",
    are_voice_greeting: "Hallo! Welches Wertpapier möchtest du analysieren? Sag mir einfach den Firmennamen und das Tickersymbol.",
  },
  en: {
    advisor_reasoning: "Advisor Reasoning Engine",
    advisor_reasoning_description: "Justify buy, hold or sell decisions with researched facts.",
    efd_agent: "Assistant Bro EFD",
    efd_agent_description: "Questions about assets, clients, net new money and income — answered straight from the EFD database.",
    efd_agent_intro: "Ask a question about the banking data, e.g. “How much assets under management do we have right now?” or “How are net new assets developing this year?”",
    efd_agent_placeholder: "Ask a question about the banking data …",
    ppi_agent: "Assistant Bro PPI",
    ppi_agent_intro: "Ask a question about the portfolios, e.g. “How is the wealth allocated across asset classes?” or “What has the performance been year to date?”",
    ppi_agent_placeholder: "Ask a question about the portfolio data …",
    efd_survista_agent: "Assistant Bro EFD",
    efd_survista_agent_intro: "Ask a question about survista’s clients, e.g. “How are the assets split across clients?” or “How much net new money have we had this year?”",
    efd_survista_agent_placeholder: "Ask a question about the survista figures …",
    efd_agent_error: "The request failed. Please try again.",
    efd_email_draft_summary: "E-mail draft to {{name}}: {{subject}}",
    efd_attachment_summary: "Document provided: {{title}}",
    efd_attachment_open: "Open",
    chart_as_of: "As of {{date}}",
    chart_show_chart: "Show as chart",
    chart_show_table: "Show as table",
    chart_building: "Building chart",
    graphs_tab: "Graphs",
    graphs_create_deck: "Create PowerPoint",
    graphs_selected: "{{count}} selected",
    graphs_select_hint: "Tick charts for the presentation",
    graphs_deck_error: "The presentation could not be created.",
    graphs_empty: "No charts saved yet. Star a chart in the chat to keep it here.",
    graphs_saved_on: "saved {{date}}",
    graphs_show: "Show chart",
    graphs_hide: "Hide chart",
    graphs_ask_again: "Ask again with current figures",
    graphs_delete: "Delete chart",
    graphs_delete_title: "Delete chart?",
    graphs_star_add: "Save to Graphs",
    graphs_star_remove: "Remove from Graphs",
    graphs_select_all: "Select all",
    graphs_delete_selected: "Delete selected",
    graphs_delete_many_title: "Delete {{count}} charts?",
    graphs_view_chart: "Chart",
    graphs_view_table: "Table",
    graphs_view_both: "Chart + table",
    graphs_all: "All",
    graphs_groups: "Groups",
    graphs_group_new: "New group",
    graphs_group_name: "Group name",
    graphs_group_exists: "This group already exists.",
    graphs_group_error: "That did not work. Please try again.",
    graphs_group_menu: "Edit group",
    graphs_group_rename: "Rename",
    graphs_group_delete: "Delete group",
    graphs_group_delete_title: "Delete group “{{name}}”?",
    graphs_group_delete_text: "The charts stay saved under “All”.",
    graphs_group_empty: "This group is still empty.",
    graphs_group_add_graphs: "Add charts",
    graphs_group_add_title: "Add charts to “{{name}}”",
    graphs_group_add_none: "All charts are already in this group.",
    graphs_group_add_confirm: "Add",
    graphs_group_deck: "PowerPoint of the group",
    graphs_group_hint: "Drag the charts into the order of the presentation.",
    graphs_groups_of: "Assign groups",
    graphs_add_to_group: "To group",
    graphs_add_to_group_title: "Add selected to a group ({{count}})",
    graphs_remove_from_group: "Remove from group",
    graphs_drag: "Drag to change the order",
    graphs_added_to_group: "Added to “{{name}}”",
    graphs_removed_from_group: "Removed from “{{name}}”",
    graphs_group_created: "Group “{{name}}” created",
    graphs_undo: "Undo",
    graphs_open_group: "Open",
    graphs_in_groups: "in groups: {{names}}",
    graphs_deck_dark: "Dark slides · click for light",
    graphs_deck_light: "Light slides · click for dark",
    graphs_deck_theme_dark: "dark slides",
    graphs_deck_theme_light: "light slides",
    attachment_open_pdf: "Open PDF",
    attachment_open_presentation: "Open presentation",
    attachment_open_document: "Open report",
    attachment_open_email: "Open e-mail",
    ts_title_stock: "theScreener report — {{name}}",
    ts_title_sector: "theScreener sector report — {{name}}",
    ts_title_industry_group: "theScreener industry group report — {{name}}",
    ts_title_index: "theScreener index report — {{name}}",
    ts_variant_complete: "Complete report",
    ts_variant_short: "Short report",
    ts_data_as_of: "Data as of {{date}}",
    ts_scope_sector: "Sector",
    ts_scope_industry_group: "Industry group",
    ts_scope_index: "Index",
    ts_worldwide: "worldwide",
    artifact_ready_powerpoint: "Presentation ready",
    artifact_ready_pdf: "PDF ready",
    artifact_ready_document: "Client report ready",
    artifact_ready_email: "E-mail prepared",
    artifact_ready_link: "Link ready",
    artifact_ready: "Ready",
    efd_agent_stage_connecting: "Connecting to the EFD database",
    efd_agent_stage_querying: "Loading current key figures",
    efd_agent_stage_composing: "Preparing your overview",
    efd_agent_welcome_error: "The overview could not be loaded — just ask your question directly.",
    efd_voice_tooltip: "Start voice conversation",
    efd_voice_mic_setup: "Preparing the microphone …",
    efd_voice_listening: "Listening …",
    efd_voice_processing: "One moment, let me check …",
    efd_voice_interrupt: "Tap to interrupt",
    efd_voice_error: "There was a problem with the voice connection.",
    efd_voice_mic_denied: "No microphone access. Please check the permission.",
    efd_vip_add: "Add prompt",
    efd_vip_add_title: "Save prompt",
    efd_vip_edit_title: "Edit prompt",
    efd_vip_delete_title: "Delete prompt?",
    efd_vip_empty: "No saved prompts yet. Save frequent questions with the star icon.",
    efd_vip_save: "Save as prompt",
    are_tab_assistant: "Assistant", are_tab_runs: "Analyses",
    // ── Not Controlled Chat (third ARE tab) — a plain ChatGPT-style chat.
    //    The tab label is a product name and stays untranslated.
    are_tab_free: "Not Controlled Chat",
    are_free_welcome: "Hi! This is a free chat — none of the Advisor Reasoning Engine's rules, but with live web search. Ask me anything.",
    are_free_placeholder: "Ask me anything …",
    are_free_searching: "Searching the web …",
    are_free_stop: "Stop",
    are_free_stopped: "Stopped.",
    are_free_empty: "No answer came back. Please try again.",
    are_free_disclaimer: "Free chat with no domain rules — AI answers can be wrong. Not investment advice.",
    // Spoken entry line for the Not Controlled Chat's voice mode. Kept short
    //   and free of markup — it goes straight to text-to-speech.
    are_free_voice_greeting: "Hi! Just ask me whatever you want to know — I can look things up online if needed.",
    session_expired: "Your session has expired. Please sign in again.",
    are_assistant_welcome: "Hi! Which security would you like to analyse? Tell me the company name and ticker (e.g. Tesla, TSLA) — optionally your leaning (buy/hold/sell). You can also ask me which analyses you already have, or have me compare them.",
    are_disclaimer: "This information was generated by AI and is an analysis of the information, not a recommendation.",
    are_translating: "This analysis was created in another language and is being translated …",
    are_assistant_placeholder: "E.g. “Analyse Tesla” or “Compare BYD with BMW”…",
    are_new_chat: "New conversation",
    are_duplicate: "Duplicate", are_duplicate_intro: "I'd like to duplicate this analysis:",
    are_started_hint: "The analysis has started. You'll find it in the “Analyses” tab.",
    are_error: "Something went wrong. Please try again.",
    are_runs_hint: "Your previous analyses", are_runs_empty: "No analyses yet. Start one via the assistant.",
    are_run_start: "Start analysis", are_run_not_started: "This analysis hasn't been run yet.",
    are_no_evidence: "No information was found for the selected period.", are_period: "Period", are_last_updated: "Last updated",
    are_cat_narratives: "Dominant narratives", are_cat_positive: "Positive developments", are_cat_negative: "Negative developments",
    are_cat_turning: "Turning points", are_cat_uncertainties: "Uncertainties",
    are_section_risk: "Risk evolution", are_section_perception: "Market perception", are_section_stability: "Narrative stability",
    are_section_news: "News environment", are_section_conflicts: "Conflicting data",
    are_overall_constructive: "Constructive", are_overall_neutral: "Neutral", are_overall_cautious: "Cautious",
    are_bericht: "Briefing", are_bericht_generating: "Generating briefing…", are_bericht_updating: "Updating briefing…", are_bericht_regenerate: "Regenerate briefing", are_prog_bericht: "Generating briefing…",
    are_more_details: "More details", are_more_details_sub: "View and edit topics & sources", are_details_themen: "Topics",
    are_position_choose: "Which decision are you looking for insights on?", are_position_pick_hint: "Pick a decision above to generate a justification.", are_position_verdict_for: "Assessment for", are_requested_leaning: "Predefined leaning", are_screener_on: "With TheScreener", are_screener_off: "Without TheScreener", are_weeks_short: "weeks",
    are_deepen: "Deepen", are_deepen_result: "Deep dive", are_new_developments: "New developments", are_open_questions: "Open questions",
    are_takeaways_title: "Key takeaways", are_details_title: "Details", are_modal_title: "Narratives & themes", are_modal_entry_sub: "View & manage all narratives", are_modal_count: "narratives", are_modal_detail_title: "Narrative details", are_modal_gone: "This narrative has been deleted.", are_modal_empty: "No analysis content yet.", are_modal_cat_empty: "No narratives in this category yet.", are_more_analysis: "More analysis", are_back_overview: "Back to analysis", are_narr_add: "Add", are_narr_add_placeholder: "Formulate a new narrative …", are_narr_edit: "Edit", are_narr_delete: "Delete", are_narr_delete_confirm: "Delete this narrative?", are_narr_advisor: "Advisor", are_deepen_focus_placeholder: "Optional focus (e.g. supply chain, margins) …", are_deepen_focus_label: "Focus",
    are_sources: "Sources", are_positioning_question: "Justify a decision:", are_buy: "Buy", are_hold: "Hold", are_sell: "Sell", are_switch_position: "Test another position:", are_refresh_arg: "Reload", are_no_arg_yet: "No argument generated for this position yet.", are_generate_arg: "Generate argument", are_tag_hint: "Tap a narrative to open it in the Details below",
    are_verdict_A: "largely supported", are_verdict_B: "partially supported", are_verdict_C: "not sufficiently supported",
    are_evidence_quality: "Evidence quality", are_supporting: "Supporting narratives", are_contradicting: "Contradicting narratives",
    are_risks_against: "Risks against the thesis",
    are_status_planning: "Planning", are_status_planned: "Planned", are_status_collecting: "Collecting", are_status_collected: "Collected",
    are_status_analyzing: "Analysing", are_status_ready: "Ready", are_status_error: "Error",
    are_prog_started: "Starting…", are_prog_screener: "Loading TheScreener data…", are_prog_search: "Searching",
    are_prog_analyzing: "Generating analysis…", are_prog_collected: "Information collected…", are_prog_working: "Please wait…", are_prog_argument: "Building the case for the decision…",
    are_hero_researching: "Building Market Intelligence…", are_hero_analyzing: "Generating the analysis…",
    are_hero_subtitle: "Scanning sources and evaluating them chronologically", are_step_screener: "TheScreener data",
    are_step_not_found: "not found",
    are_step_unavailable: "currently unavailable",
    are_delete: "Delete", are_delete_confirm: "Really delete this analysis? This cannot be undone.", are_delete_title: "Delete analysis", are_cancel: "Cancel", are_loading: "Loading analysis…",
    are_voice_tooltip: "Speak", are_voice_processing: "One moment…", are_voice_mic_setup: "Preparing microphone…",
    are_voice_listening: "Listening…", are_voice_mic_denied: "Microphone access denied", are_voice_interrupt: "Tap to interrupt",
    are_voice_you: "You", are_voice_assistant: "Assistant",
    are_voice_greeting: "Hi! Which security would you like to analyse? Just tell me the company name and its ticker symbol.",
  },
  fr: {
    advisor_reasoning: "Advisor Reasoning Engine",
    advisor_reasoning_description: "Justifiez les décisions d'achat, de conservation ou de vente avec des faits documentés.",
    efd_agent: "Assistant Bro EFD",
    efd_agent_description: "Questions sur les avoirs, les clients, les nouveaux capitaux nets et les revenus — répondues directement depuis la base EFD.",
    efd_agent_intro: "Posez une question sur les données bancaires, p. ex. « Quel est notre volume d'avoirs sous gestion actuel ? »",
    efd_agent_placeholder: "Poser une question sur les données bancaires …",
    ppi_agent: "Assistant Bro PPI",
    ppi_agent_intro: "Posez une question sur les portefeuilles, p. ex. « Comment la fortune est-elle répartie par classe d’actifs ? » ou « Quelle a été la performance depuis le début de l’année ? »",
    ppi_agent_placeholder: "Poser une question sur les données de portefeuille …",
    efd_survista_agent: "Assistant Bro EFD",
    efd_survista_agent_intro: "Pose une question sur les clients de survista, p. ex. « Comment les avoirs se répartissent-ils entre les clients ? » ou « Combien de nouveaux capitaux nets depuis le début de l’année ? »",
    efd_survista_agent_placeholder: "Poser une question sur les chiffres de survista …",
    efd_agent_error: "La requête a échoué. Veuillez réessayer.",
    efd_email_draft_summary: "Brouillon d'e-mail à {{name}} : {{subject}}",
    efd_attachment_summary: "Document fourni : {{title}}",
    efd_attachment_open: "Ouvrir",
    chart_as_of: "Au {{date}}",
    chart_show_chart: "Afficher le graphique",
    chart_show_table: "Afficher le tableau",
    chart_building: "Création du graphique",
    graphs_tab: "Graphiques",
    graphs_create_deck: "Créer un PowerPoint",
    graphs_selected: "{{count}} sélectionné(s)",
    graphs_select_hint: "Cochez les graphiques pour la présentation",
    graphs_deck_error: "La présentation n'a pas pu être créée.",
    graphs_empty: "Aucun graphique enregistré. Marquez un graphique du chat avec l'étoile.",
    graphs_saved_on: "enregistré le {{date}}",
    graphs_show: "Afficher le graphique",
    graphs_hide: "Masquer le graphique",
    graphs_ask_again: "Redemander avec les chiffres actuels",
    graphs_delete: "Supprimer le graphique",
    graphs_delete_title: "Supprimer le graphique ?",
    graphs_star_add: "Enregistrer dans Graphiques",
    graphs_star_remove: "Retirer de Graphiques",
    graphs_select_all: "Tout sélectionner",
    graphs_delete_selected: "Supprimer la sélection",
    graphs_delete_many_title: "Supprimer {{count}} graphiques ?",
    graphs_view_chart: "Graphique",
    graphs_view_table: "Tableau",
    graphs_view_both: "Graphique + tableau",
    graphs_all: "Tous",
    graphs_groups: "Groupes",
    graphs_group_new: "Nouveau groupe",
    graphs_group_name: "Nom du groupe",
    graphs_group_exists: "Ce groupe existe déjà.",
    graphs_group_error: "Cela n'a pas fonctionné. Veuillez réessayer.",
    graphs_group_menu: "Modifier le groupe",
    graphs_group_rename: "Renommer",
    graphs_group_delete: "Supprimer le groupe",
    graphs_group_delete_title: "Supprimer le groupe « {{name}} » ?",
    graphs_group_delete_text: "Les graphiques restent enregistrés sous « Tous ».",
    graphs_group_empty: "Ce groupe est encore vide.",
    graphs_group_add_graphs: "Ajouter des graphiques",
    graphs_group_add_title: "Ajouter des graphiques à « {{name}} »",
    graphs_group_add_none: "Tous les graphiques sont déjà dans ce groupe.",
    graphs_group_add_confirm: "Ajouter",
    graphs_group_deck: "PowerPoint du groupe",
    graphs_group_hint: "Faites glisser les graphiques dans l'ordre de la présentation.",
    graphs_groups_of: "Attribuer des groupes",
    graphs_add_to_group: "Vers un groupe",
    graphs_add_to_group_title: "Ajouter la sélection à un groupe ({{count}})",
    graphs_remove_from_group: "Retirer du groupe",
    graphs_drag: "Faire glisser pour changer l'ordre",
    graphs_added_to_group: "Ajouté à « {{name}} »",
    graphs_removed_from_group: "Retiré de « {{name}} »",
    graphs_group_created: "Groupe « {{name}} » créé",
    graphs_undo: "Annuler",
    graphs_open_group: "Ouvrir",
    graphs_in_groups: "dans les groupes : {{names}}",
    graphs_deck_dark: "Diapositives sombres · cliquer pour claires",
    graphs_deck_light: "Diapositives claires · cliquer pour sombres",
    graphs_deck_theme_dark: "diapositives sombres",
    graphs_deck_theme_light: "diapositives claires",
    attachment_open_pdf: "Ouvrir le PDF",
    attachment_open_presentation: "Ouvrir la présentation",
    attachment_open_document: "Ouvrir le rapport",
    attachment_open_email: "Ouvrir l'e-mail",
    ts_title_stock: "Rapport theScreener — {{name}}",
    ts_title_sector: "Rapport sectoriel theScreener — {{name}}",
    ts_title_industry_group: "Rapport theScreener du groupe industriel — {{name}}",
    ts_title_index: "Rapport d'indice theScreener — {{name}}",
    ts_variant_complete: "Rapport complet",
    ts_variant_short: "Rapport court",
    ts_data_as_of: "Données au {{date}}",
    ts_scope_sector: "Secteur",
    ts_scope_industry_group: "Groupe industriel",
    ts_scope_index: "Indice",
    ts_worldwide: "monde",
    artifact_ready_powerpoint: "Présentation prête",
    artifact_ready_pdf: "PDF prêt",
    artifact_ready_document: "Rapport client prêt",
    artifact_ready_email: "E-mail préparé",
    artifact_ready_link: "Lien prêt",
    artifact_ready: "Prêt",
    efd_agent_stage_connecting: "Connexion à la base de données EFD",
    efd_agent_stage_querying: "Chargement des indicateurs actuels",
    efd_agent_stage_composing: "Préparation de votre aperçu",
    efd_agent_welcome_error: "L'aperçu n'a pas pu être chargé — posez directement votre question.",
    efd_voice_tooltip: "Démarrer la conversation vocale",
    efd_voice_mic_setup: "Préparation du microphone …",
    efd_voice_listening: "Je vous écoute …",
    efd_voice_processing: "Un instant, je vérifie …",
    efd_voice_interrupt: "Touchez pour interrompre",
    efd_voice_error: "Problème avec la connexion vocale.",
    efd_voice_mic_denied: "Pas d'accès au microphone. Veuillez vérifier l'autorisation.",
    efd_vip_add: "Ajouter un prompt",
    efd_vip_add_title: "Enregistrer le prompt",
    efd_vip_edit_title: "Modifier le prompt",
    efd_vip_delete_title: "Supprimer le prompt ?",
    efd_vip_empty: "Aucun prompt enregistré. Enregistrez vos questions fréquentes avec l'étoile.",
    efd_vip_save: "Enregistrer comme prompt",
    are_tab_assistant: "Assistant", are_tab_runs: "Analyses",
    // ── Not Controlled Chat (third ARE tab) — a plain ChatGPT-style chat.
    //    The tab label is a product name and stays untranslated.
    are_tab_free: "Not Controlled Chat",
    are_free_welcome: "Bonjour ! Ceci est un chat libre — sans les règles de l'Advisor Reasoning Engine, mais avec la recherche web en direct. Posez-moi n'importe quelle question.",
    are_free_placeholder: "Posez-moi n'importe quelle question …",
    are_free_searching: "Recherche sur le web …",
    are_free_stop: "Arrêter",
    are_free_stopped: "Interrompu.",
    are_free_empty: "Aucune réponse n'est revenue. Veuillez réessayer.",
    are_free_disclaimer: "Chat libre sans règles métier — les réponses de l'IA peuvent être erronées. Ceci n'est pas un conseil en investissement.",
    // Spoken entry line for the Not Controlled Chat's voice mode. Kept short
    //   and free of markup — it goes straight to text-to-speech.
    are_free_voice_greeting: "Bonjour ! Demandez-moi simplement ce que vous voulez savoir, je peux aussi chercher en ligne si besoin.",
    session_expired: "Votre session a expiré. Veuillez vous reconnecter.",
    are_assistant_welcome: "Bonjour ! Quel titre souhaitez-vous analyser ? Indiquez le nom de l'entreprise et le ticker (p. ex. Tesla, TSLA) — et éventuellement votre tendance (acheter/conserver/vendre). Vous pouvez aussi me demander quelles analyses vous avez déjà, ou me les faire comparer.",
    are_disclaimer: "Ces informations ont été générées par IA et constituent une analyse des informations, et non une recommandation.",
    are_translating: "Cette analyse a été créée dans une autre langue et est en cours de traduction …",
    are_assistant_placeholder: "P. ex. « Analyse Tesla » ou « Compare BYD et BMW »…",
    are_new_chat: "Nouvelle conversation",
    are_duplicate: "Dupliquer", are_duplicate_intro: "Je souhaite dupliquer cette analyse :",
    are_started_hint: "L'analyse a démarré. Vous la trouverez dans l'onglet « Analyses ».",
    are_error: "Une erreur s'est produite. Veuillez réessayer.",
    are_runs_hint: "Vos analyses précédentes", are_runs_empty: "Aucune analyse pour l'instant. Lancez-en une via l'assistant.",
    are_run_start: "Lancer l'analyse", are_run_not_started: "Cette analyse n'a pas encore été exécutée.",
    are_no_evidence: "Aucune information trouvée pour la période sélectionnée.", are_period: "Période", are_last_updated: "Dernière mise à jour",
    are_cat_narratives: "Récits dominants", are_cat_positive: "Évolutions positives", are_cat_negative: "Évolutions négatives",
    are_cat_turning: "Points de bascule", are_cat_uncertainties: "Incertitudes",
    are_section_risk: "Évolution des risques", are_section_perception: "Perception du marché", are_section_stability: "Stabilité des récits",
    are_section_news: "Environnement médiatique", are_section_conflicts: "Données contradictoires",
    are_overall_constructive: "Plutôt constructif", are_overall_neutral: "Neutre", are_overall_cautious: "Prudent",
    are_bericht: "Briefing", are_bericht_generating: "Génération du briefing…", are_bericht_updating: "Mise à jour du briefing…", are_bericht_regenerate: "Régénérer le briefing", are_prog_bericht: "Génération du briefing…",
    are_more_details: "Plus de détails", are_more_details_sub: "Consulter et modifier les sujets et sources", are_details_themen: "Sujets",
    are_position_choose: "Pour quelle décision recherchez-vous des insights ?", are_position_pick_hint: "Choisissez une décision ci-dessus pour générer une justification.", are_position_verdict_for: "Évaluation pour", are_requested_leaning: "Tendance prédéfinie", are_screener_on: "Avec TheScreener", are_screener_off: "Sans TheScreener", are_weeks_short: "semaines",
    are_deepen: "Approfondir", are_deepen_result: "Approfondissement", are_new_developments: "Nouvelles évolutions", are_open_questions: "Questions ouvertes",
    are_takeaways_title: "Points clés", are_details_title: "Détails", are_modal_title: "Récits & thèmes", are_modal_entry_sub: "Voir & gérer tous les récits", are_modal_count: "récits", are_modal_detail_title: "Détails du récit", are_modal_gone: "Ce récit a été supprimé.", are_modal_empty: "Aucun contenu d'analyse pour le moment.", are_modal_cat_empty: "Aucun récit dans cette catégorie.", are_more_analysis: "Analyse complémentaire", are_back_overview: "Retour à l'analyse", are_narr_add: "Ajouter", are_narr_add_placeholder: "Formuler un nouveau récit …", are_narr_edit: "Modifier", are_narr_delete: "Supprimer", are_narr_delete_confirm: "Supprimer ce récit ?", are_narr_advisor: "Conseiller", are_deepen_focus_placeholder: "Focus optionnel (ex. chaîne d'approvisionnement, marges) …", are_deepen_focus_label: "Focus",
    are_sources: "Sources", are_positioning_question: "Justifier une décision :", are_buy: "Acheter", are_hold: "Conserver", are_sell: "Vendre", are_switch_position: "Tester une autre position :", are_refresh_arg: "Recharger", are_no_arg_yet: "Aucune justification générée pour cette position.", are_generate_arg: "Générer la justification", are_tag_hint: "Touchez un récit pour l'ouvrir dans les Détails ci-dessous",
    are_verdict_A: "largement étayée", are_verdict_B: "partiellement étayée", are_verdict_C: "insuffisamment étayée",
    are_evidence_quality: "Qualité des preuves", are_supporting: "Récits en faveur", are_contradicting: "Récits en défaveur",
    are_risks_against: "Risques contre la thèse",
    are_status_planning: "Planification", are_status_planned: "Planifié", are_status_collecting: "Collecte", are_status_collected: "Collecté",
    are_status_analyzing: "Analyse", are_status_ready: "Terminé", are_status_error: "Erreur",
    are_prog_started: "Démarrage…", are_prog_screener: "Chargement des données TheScreener…", are_prog_search: "Recherche",
    are_prog_analyzing: "Génération de l'analyse…", are_prog_collected: "Informations collectées…", are_prog_working: "Veuillez patienter…", are_prog_argument: "Justification de la décision…",
    are_hero_researching: "Market Intelligence en construction…", are_hero_analyzing: "Génération de l'analyse…",
    are_hero_subtitle: "Analyse des sources et évaluation chronologique", are_step_screener: "Données TheScreener",
    are_step_not_found: "introuvables",
    are_step_unavailable: "indisponibles pour le moment",
    are_delete: "Supprimer", are_delete_confirm: "Vraiment supprimer cette analyse ? Cette action est irréversible.", are_delete_title: "Supprimer l'analyse", are_cancel: "Annuler", are_loading: "Chargement de l'analyse…",
    are_voice_tooltip: "Parler", are_voice_processing: "Un instant…", are_voice_mic_setup: "Préparation du micro…",
    are_voice_listening: "J'écoute…", are_voice_mic_denied: "Accès au micro refusé", are_voice_interrupt: "Touchez pour interrompre",
    are_voice_you: "Vous", are_voice_assistant: "Assistant",
    are_voice_greeting: "Bonjour ! Quel titre souhaitez-vous analyser ? Indiquez-moi simplement le nom de l'entreprise et son symbole boursier.",
  },
  es: {
    advisor_reasoning: "Advisor Reasoning Engine",
    advisor_reasoning_description: "Justifique decisiones de compra, mantenimiento o venta con hechos documentados.",
    efd_agent: "Assistant Bro EFD",
    efd_agent_description: "Preguntas sobre patrimonio, clientes, dinero nuevo neto e ingresos — respondidas directamente desde la base de datos EFD.",
    efd_agent_intro: "Haga una pregunta sobre los datos bancarios, p. ej. «¿Cuánto patrimonio gestionamos actualmente?»",
    efd_agent_placeholder: "Hacer una pregunta sobre los datos bancarios …",
    ppi_agent: "Assistant Bro PPI",
    ppi_agent_intro: "Haz una pregunta sobre las carteras, p. ej. «¿Cómo se distribuye el patrimonio por clase de activo?» o «¿Cuál ha sido la rentabilidad en lo que va de año?»",
    ppi_agent_placeholder: "Hacer una pregunta sobre los datos de cartera …",
    efd_survista_agent: "Assistant Bro EFD",
    efd_survista_agent_intro: "Haz una pregunta sobre los clientes de survista, p. ej. «¿Cómo se reparte el patrimonio entre los clientes?» o «¿Cuánto dinero nuevo neto hemos tenido este año?»",
    efd_survista_agent_placeholder: "Hacer una pregunta sobre las cifras de survista …",
    efd_agent_error: "La solicitud ha fallado. Inténtelo de nuevo.",
    efd_email_draft_summary: "Borrador de correo para {{name}}: {{subject}}",
    efd_attachment_summary: "Documento facilitado: {{title}}",
    efd_attachment_open: "Abrir",
    chart_as_of: "A {{date}}",
    chart_show_chart: "Mostrar como gráfico",
    chart_show_table: "Mostrar como tabla",
    chart_building: "Creando el gráfico",
    graphs_tab: "Gráficos",
    graphs_create_deck: "Crear PowerPoint",
    graphs_selected: "{{count}} seleccionado(s)",
    graphs_select_hint: "Marca los gráficos para la presentación",
    graphs_deck_error: "No se pudo crear la presentación.",
    graphs_empty: "Aún no hay gráficos guardados. Marca un gráfico del chat con la estrella.",
    graphs_saved_on: "guardado el {{date}}",
    graphs_show: "Mostrar gráfico",
    graphs_hide: "Ocultar gráfico",
    graphs_ask_again: "Preguntar de nuevo con cifras actuales",
    graphs_delete: "Eliminar gráfico",
    graphs_delete_title: "¿Eliminar gráfico?",
    graphs_star_add: "Guardar en Gráficos",
    graphs_star_remove: "Quitar de Gráficos",
    graphs_select_all: "Seleccionar todo",
    graphs_delete_selected: "Eliminar selección",
    graphs_delete_many_title: "¿Eliminar {{count}} gráficos?",
    graphs_view_chart: "Gráfico",
    graphs_view_table: "Tabla",
    graphs_view_both: "Gráfico + tabla",
    graphs_all: "Todos",
    graphs_groups: "Grupos",
    graphs_group_new: "Nuevo grupo",
    graphs_group_name: "Nombre del grupo",
    graphs_group_exists: "Este grupo ya existe.",
    graphs_group_error: "No ha funcionado. Inténtalo de nuevo.",
    graphs_group_menu: "Editar grupo",
    graphs_group_rename: "Renombrar",
    graphs_group_delete: "Eliminar grupo",
    graphs_group_delete_title: "¿Eliminar el grupo «{{name}}»?",
    graphs_group_delete_text: "Los gráficos siguen guardados en «Todos».",
    graphs_group_empty: "Este grupo todavía está vacío.",
    graphs_group_add_graphs: "Añadir gráficos",
    graphs_group_add_title: "Añadir gráficos a «{{name}}»",
    graphs_group_add_none: "Todos los gráficos ya están en este grupo.",
    graphs_group_add_confirm: "Añadir",
    graphs_group_deck: "PowerPoint del grupo",
    graphs_group_hint: "Arrastra los gráficos al orden de la presentación.",
    graphs_groups_of: "Asignar grupos",
    graphs_add_to_group: "A un grupo",
    graphs_add_to_group_title: "Añadir la selección a un grupo ({{count}})",
    graphs_remove_from_group: "Quitar del grupo",
    graphs_drag: "Arrastra para cambiar el orden",
    graphs_added_to_group: "Añadido a «{{name}}»",
    graphs_removed_from_group: "Quitado de «{{name}}»",
    graphs_group_created: "Grupo «{{name}}» creado",
    graphs_undo: "Deshacer",
    graphs_open_group: "Abrir",
    graphs_in_groups: "en grupos: {{names}}",
    graphs_deck_dark: "Diapositivas oscuras · clic para claras",
    graphs_deck_light: "Diapositivas claras · clic para oscuras",
    graphs_deck_theme_dark: "diapositivas oscuras",
    graphs_deck_theme_light: "diapositivas claras",
    attachment_open_pdf: "Abrir PDF",
    attachment_open_presentation: "Abrir presentación",
    attachment_open_document: "Abrir informe",
    attachment_open_email: "Abrir correo",
    ts_title_stock: "Informe theScreener — {{name}}",
    ts_title_sector: "Informe sectorial theScreener — {{name}}",
    ts_title_industry_group: "Informe theScreener del grupo industrial — {{name}}",
    ts_title_index: "Informe de índice theScreener — {{name}}",
    ts_variant_complete: "Informe completo",
    ts_variant_short: "Informe breve",
    ts_data_as_of: "Datos a {{date}}",
    ts_scope_sector: "Sector",
    ts_scope_industry_group: "Grupo industrial",
    ts_scope_index: "Índice",
    ts_worldwide: "mundial",
    artifact_ready_powerpoint: "Presentación lista",
    artifact_ready_pdf: "PDF listo",
    artifact_ready_document: "Informe de cliente listo",
    artifact_ready_email: "Correo preparado",
    artifact_ready_link: "Enlace listo",
    artifact_ready: "Listo",
    efd_agent_stage_connecting: "Conectando con la base de datos EFD",
    efd_agent_stage_querying: "Cargando los indicadores actuales",
    efd_agent_stage_composing: "Preparando su resumen",
    efd_agent_welcome_error: "No se pudo cargar el resumen — haga su pregunta directamente.",
    efd_voice_tooltip: "Iniciar conversación por voz",
    efd_voice_mic_setup: "Preparando el micrófono …",
    efd_voice_listening: "Le escucho …",
    efd_voice_processing: "Un momento, lo consulto …",
    efd_voice_interrupt: "Toque para interrumpir",
    efd_voice_error: "Ha habido un problema con la conexión de voz.",
    efd_voice_mic_denied: "Sin acceso al micrófono. Compruebe el permiso.",
    efd_vip_add: "Añadir prompt",
    efd_vip_add_title: "Guardar prompt",
    efd_vip_edit_title: "Editar prompt",
    efd_vip_delete_title: "¿Eliminar el prompt?",
    efd_vip_empty: "Aún no hay prompts guardados. Guarde sus preguntas frecuentes con la estrella.",
    efd_vip_save: "Guardar como prompt",
    are_tab_assistant: "Asistente", are_tab_runs: "Análisis",
    // ── Not Controlled Chat (third ARE tab) — a plain ChatGPT-style chat.
    //    The tab label is a product name and stays untranslated.
    are_tab_free: "Not Controlled Chat",
    are_free_welcome: "¡Hola! Este es un chat libre — sin las reglas del Advisor Reasoning Engine, pero con búsqueda web en vivo. Pregúntame lo que quieras.",
    are_free_placeholder: "Pregúntame lo que quieras …",
    are_free_searching: "Buscando en la web …",
    are_free_stop: "Detener",
    are_free_stopped: "Interrumpido.",
    are_free_empty: "No se recibió ninguna respuesta. Inténtalo de nuevo.",
    are_free_disclaimer: "Chat libre sin reglas técnicas — las respuestas de la IA pueden ser incorrectas. No es asesoramiento de inversión.",
    // Spoken entry line for the Not Controlled Chat's voice mode. Kept short
    //   and free of markup — it goes straight to text-to-speech.
    are_free_voice_greeting: "¡Hola! Pregúntame lo que quieras saber; si hace falta también puedo buscarlo en internet.",
    session_expired: "Tu sesión ha caducado. Inicia sesión de nuevo.",
    are_assistant_welcome: "¡Hola! ¿Qué valor desea analizar? Indíqueme el nombre de la empresa y el ticker (p. ej. Tesla, TSLA) y, opcionalmente, su tendencia (comprar/mantener/vender). También puede preguntarme qué análisis tiene ya o pedirme que los compare.",
    are_disclaimer: "Esta información ha sido generada por IA y constituye un análisis de la información, no una recomendación.",
    are_translating: "Este análisis se creó en otro idioma y se está traduciendo …",
    are_assistant_placeholder: "P. ej. «Analiza Tesla» o «Compara BYD con BMW»…",
    are_new_chat: "Nueva conversación",
    are_duplicate: "Duplicar", are_duplicate_intro: "Quiero duplicar este análisis:",
    are_started_hint: "El análisis ha comenzado. Lo encontrará en la pestaña «Análisis».",
    are_error: "Se ha producido un error. Inténtelo de nuevo.",
    are_runs_hint: "Sus análisis anteriores", are_runs_empty: "Aún no hay análisis. Inicie uno mediante el asistente.",
    are_run_start: "Iniciar análisis", are_run_not_started: "Este análisis aún no se ha ejecutado.",
    are_no_evidence: "No se encontró información para el período seleccionado.", are_period: "Período", are_last_updated: "Última actualización",
    are_cat_narratives: "Narrativas dominantes", are_cat_positive: "Desarrollos positivos", are_cat_negative: "Desarrollos negativos",
    are_cat_turning: "Puntos de inflexión", are_cat_uncertainties: "Incertidumbres",
    are_section_risk: "Evolución del riesgo", are_section_perception: "Percepción del mercado", are_section_stability: "Estabilidad de las narrativas",
    are_section_news: "Entorno de noticias", are_section_conflicts: "Datos contradictorios",
    are_overall_constructive: "Más bien constructivo", are_overall_neutral: "Neutral", are_overall_cautious: "Cauteloso",
    are_bericht: "Briefing", are_bericht_generating: "Generando el briefing…", are_bericht_updating: "Actualizando el briefing…", are_bericht_regenerate: "Regenerar el briefing", are_prog_bericht: "Generando el briefing…",
    are_more_details: "Más detalles", are_more_details_sub: "Ver y editar temas y fuentes", are_details_themen: "Temas",
    are_position_choose: "¿Para qué decisión busca insights?", are_position_pick_hint: "Elija una decisión arriba para generar una justificación.", are_position_verdict_for: "Evaluación para", are_requested_leaning: "Tendencia predefinida", are_screener_on: "Con TheScreener", are_screener_off: "Sin TheScreener", are_weeks_short: "semanas",
    are_deepen: "Profundizar", are_deepen_result: "Profundización", are_new_developments: "Nuevos desarrollos", are_open_questions: "Preguntas abiertas",
    are_takeaways_title: "Puntos clave", are_details_title: "Detalles", are_modal_title: "Narrativas y temas", are_modal_entry_sub: "Ver y gestionar todas las narrativas", are_modal_count: "narrativas", are_modal_detail_title: "Detalles de la narrativa", are_modal_gone: "Esta narrativa ha sido eliminada.", are_modal_empty: "Aún no hay contenido de análisis.", are_modal_cat_empty: "Aún no hay narrativas en esta categoría.", are_more_analysis: "Más análisis", are_back_overview: "Volver al análisis", are_narr_add: "Añadir", are_narr_add_placeholder: "Formular una nueva narrativa …", are_narr_edit: "Editar", are_narr_delete: "Eliminar", are_narr_delete_confirm: "¿Eliminar esta narrativa?", are_narr_advisor: "Asesor", are_deepen_focus_placeholder: "Enfoque opcional (p. ej. cadena de suministro, márgenes) …", are_deepen_focus_label: "Enfoque",
    are_sources: "Fuentes", are_positioning_question: "Justificar una decisión:", are_buy: "Comprar", are_hold: "Mantener", are_sell: "Vender", are_switch_position: "Probar otra posición:", are_refresh_arg: "Recargar", are_no_arg_yet: "Aún no se ha generado una justificación para esta posición.", are_generate_arg: "Generar justificación", are_tag_hint: "Toca un relato para abrirlo en los Detalles de abajo",
    are_verdict_A: "ampliamente respaldada", are_verdict_B: "parcialmente respaldada", are_verdict_C: "no suficientemente respaldada",
    are_evidence_quality: "Calidad de la evidencia", are_supporting: "Narrativas a favor", are_contradicting: "Narrativas en contra",
    are_risks_against: "Riesgos contra la tesis",
    are_status_planning: "Planificación", are_status_planned: "Planificado", are_status_collecting: "Recopilando", are_status_collected: "Recopilado",
    are_status_analyzing: "Analizando", are_status_ready: "Listo", are_status_error: "Error",
    are_prog_started: "Iniciando…", are_prog_screener: "Cargando datos de TheScreener…", are_prog_search: "Buscando",
    are_prog_analyzing: "Generando el análisis…", are_prog_collected: "Información recopilada…", are_prog_working: "Espere por favor…", are_prog_argument: "Fundamentando la decisión…",
    are_hero_researching: "Market Intelligence en construcción…", are_hero_analyzing: "Generando el análisis…",
    are_hero_subtitle: "Explorando fuentes y evaluándolas cronológicamente", are_step_screener: "Datos de TheScreener",
    are_step_not_found: "no encontrados",
    are_step_unavailable: "no disponibles en este momento",
    are_delete: "Eliminar", are_delete_confirm: "¿Eliminar realmente este análisis? Esta acción no se puede deshacer.", are_delete_title: "Eliminar análisis", are_cancel: "Cancelar", are_loading: "Cargando análisis…",
    are_voice_tooltip: "Hablar", are_voice_processing: "Un momento…", are_voice_mic_setup: "Preparando el micrófono…",
    are_voice_listening: "Escuchando…", are_voice_mic_denied: "Acceso al micrófono denegado", are_voice_interrupt: "Toca para interrumpir",
    are_voice_you: "Usted", are_voice_assistant: "Asistente",
    are_voice_greeting: "¡Hola! ¿Qué valor desea analizar? Solo dígame el nombre de la empresa y su símbolo bursátil.",
  },
  it: {
    advisor_reasoning: "Advisor Reasoning Engine",
    advisor_reasoning_description: "Giustifica le decisioni di acquisto, mantenimento o vendita con fatti documentati.",
    efd_agent: "Assistant Bro EFD",
    efd_agent_description: "Domande su patrimoni, clienti, nuova raccolta netta e ricavi — risposte direttamente dal database EFD.",
    efd_agent_intro: "Fai una domanda sui dati bancari, ad es. «Quanto patrimonio gestiamo attualmente?»",
    efd_agent_placeholder: "Fai una domanda sui dati bancari …",
    ppi_agent: "Assistant Bro PPI",
    ppi_agent_intro: "Fai una domanda sui portafogli, ad es. «Come è distribuito il patrimonio per classe di attivi?» oppure «Qual è stata la performance da inizio anno?»",
    ppi_agent_placeholder: "Fai una domanda sui dati di portafoglio …",
    efd_survista_agent: "Assistant Bro EFD",
    efd_survista_agent_intro: "Fai una domanda sui clienti di survista, ad es. «Come si distribuisce il patrimonio tra i clienti?» oppure «Quanta nuova raccolta netta abbiamo avuto da inizio anno?»",
    efd_survista_agent_placeholder: "Fai una domanda sulle cifre di survista …",
    efd_agent_error: "La richiesta non è riuscita. Riprova.",
    efd_email_draft_summary: "Bozza e-mail a {{name}}: {{subject}}",
    efd_attachment_summary: "Documento fornito: {{title}}",
    efd_attachment_open: "Apri",
    chart_as_of: "Al {{date}}",
    chart_show_chart: "Mostra come grafico",
    chart_show_table: "Mostra come tabella",
    chart_building: "Creazione del grafico",
    graphs_tab: "Grafici",
    graphs_create_deck: "Crea PowerPoint",
    graphs_selected: "{{count}} selezionati",
    graphs_select_hint: "Seleziona i grafici per la presentazione",
    graphs_deck_error: "Non è stato possibile creare la presentazione.",
    graphs_empty: "Nessun grafico salvato. Segna un grafico nella chat con la stella.",
    graphs_saved_on: "salvato il {{date}}",
    graphs_show: "Mostra grafico",
    graphs_hide: "Nascondi grafico",
    graphs_ask_again: "Chiedi di nuovo con i dati attuali",
    graphs_delete: "Elimina grafico",
    graphs_delete_title: "Eliminare il grafico?",
    graphs_star_add: "Salva in Grafici",
    graphs_star_remove: "Rimuovi da Grafici",
    graphs_select_all: "Seleziona tutto",
    graphs_delete_selected: "Elimina selezionati",
    graphs_delete_many_title: "Eliminare {{count}} grafici?",
    graphs_view_chart: "Grafico",
    graphs_view_table: "Tabella",
    graphs_view_both: "Grafico + tabella",
    graphs_all: "Tutti",
    graphs_groups: "Gruppi",
    graphs_group_new: "Nuovo gruppo",
    graphs_group_name: "Nome del gruppo",
    graphs_group_exists: "Questo gruppo esiste già.",
    graphs_group_error: "Non ha funzionato. Riprova.",
    graphs_group_menu: "Modifica gruppo",
    graphs_group_rename: "Rinomina",
    graphs_group_delete: "Elimina gruppo",
    graphs_group_delete_title: "Eliminare il gruppo «{{name}}»?",
    graphs_group_delete_text: "I grafici restano salvati in «Tutti».",
    graphs_group_empty: "Questo gruppo è ancora vuoto.",
    graphs_group_add_graphs: "Aggiungi grafici",
    graphs_group_add_title: "Aggiungi grafici a «{{name}}»",
    graphs_group_add_none: "Tutti i grafici sono già in questo gruppo.",
    graphs_group_add_confirm: "Aggiungi",
    graphs_group_deck: "PowerPoint del gruppo",
    graphs_group_hint: "Trascina i grafici nell'ordine della presentazione.",
    graphs_groups_of: "Assegna gruppi",
    graphs_add_to_group: "A un gruppo",
    graphs_add_to_group_title: "Aggiungi la selezione a un gruppo ({{count}})",
    graphs_remove_from_group: "Rimuovi dal gruppo",
    graphs_drag: "Trascina per cambiare l'ordine",
    graphs_added_to_group: "Aggiunto a «{{name}}»",
    graphs_removed_from_group: "Rimosso da «{{name}}»",
    graphs_group_created: "Gruppo «{{name}}» creato",
    graphs_undo: "Annulla",
    graphs_open_group: "Apri",
    graphs_in_groups: "nei gruppi: {{names}}",
    graphs_deck_dark: "Slide scure · clic per chiare",
    graphs_deck_light: "Slide chiare · clic per scure",
    graphs_deck_theme_dark: "slide scure",
    graphs_deck_theme_light: "slide chiare",
    attachment_open_pdf: "Apri PDF",
    attachment_open_presentation: "Apri presentazione",
    attachment_open_document: "Apri report",
    attachment_open_email: "Apri e-mail",
    ts_title_stock: "Report theScreener — {{name}}",
    ts_title_sector: "Report settoriale theScreener — {{name}}",
    ts_title_industry_group: "Report theScreener del gruppo industriale — {{name}}",
    ts_title_index: "Report indice theScreener — {{name}}",
    ts_variant_complete: "Report completo",
    ts_variant_short: "Report breve",
    ts_data_as_of: "Dati al {{date}}",
    ts_scope_sector: "Settore",
    ts_scope_industry_group: "Gruppo industriale",
    ts_scope_index: "Indice",
    ts_worldwide: "mondiale",
    artifact_ready_powerpoint: "Presentazione pronta",
    artifact_ready_pdf: "PDF pronto",
    artifact_ready_document: "Report cliente pronto",
    artifact_ready_email: "E-mail preparata",
    artifact_ready_link: "Link pronto",
    artifact_ready: "Pronto",
    efd_agent_stage_connecting: "Connessione al database EFD",
    efd_agent_stage_querying: "Caricamento degli indicatori attuali",
    efd_agent_stage_composing: "Preparazione della panoramica",
    efd_agent_welcome_error: "Non è stato possibile caricare la panoramica — poni direttamente la tua domanda.",
    efd_voice_tooltip: "Avvia conversazione vocale",
    efd_voice_mic_setup: "Preparazione del microfono …",
    efd_voice_listening: "Ti ascolto …",
    efd_voice_processing: "Un momento, controllo …",
    efd_voice_interrupt: "Tocca per interrompere",
    efd_voice_error: "Si è verificato un problema con la connessione vocale.",
    efd_voice_mic_denied: "Nessun accesso al microfono. Controlla l'autorizzazione.",
    efd_vip_add: "Aggiungi prompt",
    efd_vip_add_title: "Salva prompt",
    efd_vip_edit_title: "Modifica prompt",
    efd_vip_delete_title: "Eliminare il prompt?",
    efd_vip_empty: "Nessun prompt salvato. Salva le domande frequenti con la stella.",
    efd_vip_save: "Salva come prompt",
    are_tab_assistant: "Assistente", are_tab_runs: "Analisi",
    // ── Not Controlled Chat (third ARE tab) — a plain ChatGPT-style chat.
    //    The tab label is a product name and stays untranslated.
    are_tab_free: "Not Controlled Chat",
    are_free_welcome: "Ciao! Questa è una chat libera — senza le regole dell'Advisor Reasoning Engine, ma con la ricerca web in tempo reale. Chiedimi quello che vuoi.",
    are_free_placeholder: "Chiedimi qualsiasi cosa …",
    are_free_searching: "Ricerca sul web …",
    are_free_stop: "Ferma",
    are_free_stopped: "Interrotto.",
    are_free_empty: "Non è arrivata alcuna risposta. Riprova.",
    are_free_disclaimer: "Chat libera senza regole di dominio — le risposte dell'IA possono essere errate. Non è consulenza in materia di investimenti.",
    // Spoken entry line for the Not Controlled Chat's voice mode. Kept short
    //   and free of markup — it goes straight to text-to-speech.
    are_free_voice_greeting: "Ciao! Chiedimi pure quello che vuoi sapere, se serve posso anche cercarlo online.",
    session_expired: "La tua sessione è scaduta. Accedi di nuovo.",
    are_assistant_welcome: "Ciao! Quale titolo desidera analizzare? Mi indichi il nome dell'azienda e il ticker (es. Tesla, TSLA) e, facoltativamente, la sua tendenza (comprare/mantenere/vendere). Può anche chiedermi quali analisi ha già o farmele confrontare.",
    are_disclaimer: "Queste informazioni sono state generate dall'IA e costituiscono un'analisi delle informazioni, non una raccomandazione.",
    are_translating: "Questa analisi è stata creata in un'altra lingua ed è in fase di traduzione …",
    are_assistant_placeholder: "Es. «Analizza Tesla» o «Confronta BYD con BMW»…",
    are_new_chat: "Nuova conversazione",
    are_duplicate: "Duplica", are_duplicate_intro: "Vorrei duplicare questa analisi:",
    are_started_hint: "L'analisi è stata avviata. La trova nella scheda «Analisi».",
    are_error: "Si è verificato un errore. Riprovare.",
    are_runs_hint: "Le tue analisi precedenti", are_runs_empty: "Ancora nessuna analisi. Avviane una tramite l'assistente.",
    are_run_start: "Avvia analisi", are_run_not_started: "Questa analisi non è ancora stata eseguita.",
    are_no_evidence: "Nessuna informazione trovata per il periodo selezionato.", are_period: "Periodo", are_last_updated: "Ultimo aggiornamento",
    are_cat_narratives: "Narrazioni dominanti", are_cat_positive: "Sviluppi positivi", are_cat_negative: "Sviluppi negativi",
    are_cat_turning: "Punti di svolta", are_cat_uncertainties: "Incertezze",
    are_section_risk: "Evoluzione del rischio", are_section_perception: "Percezione del mercato", are_section_stability: "Stabilità delle narrazioni",
    are_section_news: "Contesto delle notizie", are_section_conflicts: "Dati contraddittori",
    are_overall_constructive: "Piuttosto costruttivo", are_overall_neutral: "Neutrale", are_overall_cautious: "Cauto",
    are_bericht: "Briefing", are_bericht_generating: "Generazione del briefing…", are_bericht_updating: "Aggiornamento del briefing…", are_bericht_regenerate: "Rigenera il briefing", are_prog_bericht: "Generazione del briefing…",
    are_more_details: "Più dettagli", are_more_details_sub: "Visualizza e modifica temi e fonti", are_details_themen: "Temi",
    are_position_choose: "Per quale decisione cerca insights?", are_position_pick_hint: "Scegli una decisione sopra per generare una motivazione.", are_position_verdict_for: "Valutazione per", are_requested_leaning: "Tendenza predefinita", are_screener_on: "Con TheScreener", are_screener_off: "Senza TheScreener", are_weeks_short: "settimane",
    are_deepen: "Approfondisci", are_deepen_result: "Approfondimento", are_new_developments: "Nuovi sviluppi", are_open_questions: "Domande aperte",
    are_takeaways_title: "Punti chiave", are_details_title: "Dettagli", are_modal_title: "Narrazioni e temi", are_modal_entry_sub: "Visualizza e gestisci tutte le narrazioni", are_modal_count: "narrazioni", are_modal_detail_title: "Dettagli della narrazione", are_modal_gone: "Questa narrazione è stata eliminata.", are_modal_empty: "Ancora nessun contenuto di analisi.", are_modal_cat_empty: "Ancora nessuna narrazione in questa categoria.", are_more_analysis: "Ulteriore analisi", are_back_overview: "Torna all'analisi", are_narr_add: "Aggiungi", are_narr_add_placeholder: "Formula una nuova narrativa …", are_narr_edit: "Modifica", are_narr_delete: "Elimina", are_narr_delete_confirm: "Eliminare questa narrativa?", are_narr_advisor: "Consulente", are_deepen_focus_placeholder: "Focus opzionale (es. catena di fornitura, margini) …", are_deepen_focus_label: "Focus",
    are_sources: "Fonti", are_positioning_question: "Giustifica una decisione:", are_buy: "Comprare", are_hold: "Mantenere", are_sell: "Vendere", are_switch_position: "Verifica un'altra posizione:", are_refresh_arg: "Ricarica", are_no_arg_yet: "Nessuna motivazione generata per questa posizione.", are_generate_arg: "Genera motivazione", are_tag_hint: "Tocca un racconto per aprirlo nei Dettagli qui sotto",
    are_verdict_A: "ampiamente supportata", are_verdict_B: "parzialmente supportata", are_verdict_C: "non sufficientemente supportata",
    are_evidence_quality: "Qualità delle prove", are_supporting: "Narrazioni a favore", are_contradicting: "Narrazioni contrarie",
    are_risks_against: "Rischi contro la tesi",
    are_status_planning: "Pianificazione", are_status_planned: "Pianificato", are_status_collecting: "Raccolta", are_status_collected: "Raccolto",
    are_status_analyzing: "Analisi", are_status_ready: "Pronto", are_status_error: "Errore",
    are_prog_started: "Avvio…", are_prog_screener: "Caricamento dati TheScreener…", are_prog_search: "Ricerca",
    are_prog_analyzing: "Generazione dell'analisi…", are_prog_collected: "Informazioni raccolte…", are_prog_working: "Attendere prego…", are_prog_argument: "Motivazione della decisione…",
    are_hero_researching: "Market Intelligence in costruzione…", are_hero_analyzing: "Generazione dell'analisi…",
    are_hero_subtitle: "Scansione delle fonti e valutazione cronologica", are_step_screener: "Dati TheScreener",
    are_step_not_found: "non trovati",
    are_step_unavailable: "al momento non disponibili",
    are_delete: "Elimina", are_delete_confirm: "Eliminare davvero questa analisi? L'operazione non può essere annullata.", are_delete_title: "Elimina analisi", are_cancel: "Annulla", are_loading: "Caricamento dell'analisi…",
    are_voice_tooltip: "Parla", are_voice_processing: "Un momento…", are_voice_mic_setup: "Preparazione del microfono…",
    are_voice_listening: "Sto ascoltando…", are_voice_mic_denied: "Accesso al microfono negato", are_voice_interrupt: "Tocca per interrompere",
    are_voice_you: "Tu", are_voice_assistant: "Assistente",
    are_voice_greeting: "Ciao! Quale titolo desidera analizzare? Mi dica semplicemente il nome dell'azienda e il suo simbolo di borsa.",
  },
};
Object.keys(areTranslations).forEach((lng) => {
  if (!resources[lng]) resources[lng] = { translation: {} };
  if (!resources[lng].translation) resources[lng].translation = {};
  Object.assign(resources[lng].translation, areTranslations[lng]);
});

// ── Chat UI keys (tooltips, VIP dialogs, header buttons) — merged per language ──
const chatUiTranslations = {
  de: {
    send_tooltip: "Nachricht senden",
    stt_tooltip: "Spracheingabe – Sprache zu Text",
    stt_stop_tooltip: "Aufnahme stoppen",
    voice_tooltip: "KI-Sprachagent starten",
    voice_stop_tooltip: "Sprachmodus beenden",
    vip_tooltip: "Diese Frage als VIP-Prompt speichern",
    clear_chat: "Chat leeren",
    no_chat_history: "Noch kein Chatverlauf vorhanden.",
    assistant_disclaimer: "Die Antworten werden von KI generiert, können Fehler enthalten und stellen keine Anlageberatung dar.",
    vip_save_title: "Als VIP speichern",
    vip_save_desc: "Diesen Prompt als „Very Important Prompt“ speichern, um ihn später schnell wiederzuverwenden.",
    vip_prompt_label: "Prompt",
    vip_save_confirm: "Speichern",
    vip_cancel: "Abbrechen",
    vip_saved_success: "Als VIP gespeichert.",
    vip_saved_error: "Speichern fehlgeschlagen. Bitte erneut versuchen.",
    vip_delete_title: "VIP löschen",
    vip_delete_desc: "Diesen gespeicherten Prompt wirklich löschen? Das kann nicht rückgängig gemacht werden.",
    vip_delete_confirm: "Löschen",
    vip_deleted_success: "VIP gelöscht.",
    vip_deleted_error: "Löschen fehlgeschlagen. Bitte erneut versuchen.",
    // Protected report links (theScreener PDFs) are fetched with the login
    //   token and opened in a new tab — see openAuthenticatedFile in auth.js.
    //   The error keys mirror the backend's error codes.
    file_loading: "Report wird geladen …",
    file_error_not_available: "Dieser Report ist derzeit nicht verfügbar.",
    file_error_temporarily_unavailable: "Der Report ist vorübergehend nicht erreichbar. Bitte später erneut versuchen.",
    file_error_rate_limited: "Zu viele Report-Abrufe in kurzer Zeit. Bitte gleich noch einmal versuchen.",
    file_error_upstream_misconfigured: "Der Zugang zu theScreener ist derzeit gestört. Bitte später erneut versuchen.",
    file_error_bad_request: "Dieser Report-Link ist ungültig. Bitte den Report im Assistenten neu anfordern.",
    file_error_generic: "Der Report konnte nicht geöffnet werden. Bitte später erneut versuchen.",
  },
  en: {
    send_tooltip: "Send message",
    stt_tooltip: "Voice input – speech to text",
    stt_stop_tooltip: "Stop recording",
    voice_tooltip: "Start AI voice agent",
    voice_stop_tooltip: "Exit voice mode",
    vip_tooltip: "Save this question as a VIP prompt",
    clear_chat: "Clear Chat",
    no_chat_history: "No chat history yet.",
    assistant_disclaimer: "Responses are generated by AI, may contain errors and do not constitute investment advice.",
    vip_save_title: "Save as VIP",
    vip_save_desc: "Save this prompt as a “Very Important Prompt” to quickly reuse it later.",
    vip_prompt_label: "Prompt",
    vip_save_confirm: "Save",
    vip_cancel: "Cancel",
    vip_saved_success: "Saved as VIP.",
    vip_saved_error: "Saving failed. Please try again.",
    vip_delete_title: "Delete VIP",
    vip_delete_desc: "Really delete this saved prompt? This cannot be undone.",
    vip_delete_confirm: "Delete",
    vip_deleted_success: "VIP deleted.",
    vip_deleted_error: "Deletion failed. Please try again.",
    file_loading: "Loading report …",
    file_error_not_available: "This report is currently not available.",
    file_error_temporarily_unavailable: "The report is temporarily unavailable. Please try again later.",
    file_error_rate_limited: "Too many report requests in a short time. Please try again in a moment.",
    file_error_upstream_misconfigured: "Access to theScreener is currently disrupted. Please try again later.",
    file_error_bad_request: "This report link is invalid. Please request the report again in the assistant.",
    file_error_generic: "The report could not be opened. Please try again later.",
  },
  fr: {
    send_tooltip: "Envoyer le message",
    stt_tooltip: "Saisie vocale – parole en texte",
    stt_stop_tooltip: "Arrêter l'enregistrement",
    voice_tooltip: "Démarrer l'agent vocal IA",
    voice_stop_tooltip: "Quitter le mode vocal",
    vip_tooltip: "Enregistrer cette question comme prompt VIP",
    clear_chat: "Effacer le chat",
    no_chat_history: "Aucun historique de chat pour le moment.",
    assistant_disclaimer: "Les réponses sont générées par IA, peuvent contenir des erreurs et ne constituent pas un conseil en investissement.",
    vip_save_title: "Enregistrer comme VIP",
    vip_save_desc: "Enregistrer ce prompt comme « Very Important Prompt » pour le réutiliser rapidement plus tard.",
    vip_prompt_label: "Prompt",
    vip_save_confirm: "Enregistrer",
    vip_cancel: "Annuler",
    vip_saved_success: "Enregistré comme VIP.",
    vip_saved_error: "Échec de l'enregistrement. Veuillez réessayer.",
    vip_delete_title: "Supprimer le VIP",
    vip_delete_desc: "Voulez-vous vraiment supprimer ce prompt enregistré ? Cette action est irréversible.",
    vip_delete_confirm: "Supprimer",
    vip_deleted_success: "VIP supprimé.",
    vip_deleted_error: "Échec de la suppression. Veuillez réessayer.",
    file_loading: "Chargement du rapport …",
    file_error_not_available: "Ce rapport n'est pas disponible pour le moment.",
    file_error_temporarily_unavailable: "Le rapport est temporairement inaccessible. Veuillez réessayer plus tard.",
    file_error_rate_limited: "Trop de demandes de rapports en peu de temps. Veuillez réessayer dans un instant.",
    file_error_upstream_misconfigured: "L'accès à theScreener est actuellement perturbé. Veuillez réessayer plus tard.",
    file_error_bad_request: "Ce lien de rapport n'est pas valide. Veuillez redemander le rapport dans l'assistant.",
    file_error_generic: "Le rapport n'a pas pu être ouvert. Veuillez réessayer plus tard.",
  },
  es: {
    send_tooltip: "Enviar mensaje",
    stt_tooltip: "Entrada de voz – voz a texto",
    stt_stop_tooltip: "Detener grabación",
    voice_tooltip: "Iniciar agente de voz IA",
    voice_stop_tooltip: "Salir del modo de voz",
    vip_tooltip: "Guardar esta pregunta como prompt VIP",
    clear_chat: "Vaciar chat",
    no_chat_history: "Aún no hay historial de chat.",
    assistant_disclaimer: "Las respuestas se generan por IA, pueden contener errores y no constituyen asesoramiento de inversión.",
    vip_save_title: "Guardar como VIP",
    vip_save_desc: "Guarda este prompt como «Very Important Prompt» para reutilizarlo rápidamente más tarde.",
    vip_prompt_label: "Prompt",
    vip_save_confirm: "Guardar",
    vip_cancel: "Cancelar",
    vip_saved_success: "Guardado como VIP.",
    vip_saved_error: "Error al guardar. Inténtalo de nuevo.",
    vip_delete_title: "Eliminar VIP",
    vip_delete_desc: "¿Seguro que quieres eliminar este prompt guardado? Esta acción no se puede deshacer.",
    vip_delete_confirm: "Eliminar",
    vip_deleted_success: "VIP eliminado.",
    vip_deleted_error: "Error al eliminar. Inténtalo de nuevo.",
    file_loading: "Cargando el informe …",
    file_error_not_available: "Este informe no está disponible en este momento.",
    file_error_temporarily_unavailable: "El informe no está accesible temporalmente. Inténtalo de nuevo más tarde.",
    file_error_rate_limited: "Demasiadas solicitudes de informes en poco tiempo. Inténtalo de nuevo en un momento.",
    file_error_upstream_misconfigured: "El acceso a theScreener está interrumpido en este momento. Inténtalo de nuevo más tarde.",
    file_error_bad_request: "Este enlace de informe no es válido. Vuelve a solicitar el informe en el asistente.",
    file_error_generic: "No se pudo abrir el informe. Inténtalo de nuevo más tarde.",
  },
  it: {
    send_tooltip: "Invia messaggio",
    stt_tooltip: "Input vocale – voce in testo",
    stt_stop_tooltip: "Interrompi registrazione",
    voice_tooltip: "Avvia agente vocale IA",
    voice_stop_tooltip: "Esci dalla modalità vocale",
    vip_tooltip: "Salva questa domanda come prompt VIP",
    clear_chat: "Svuota chat",
    no_chat_history: "Nessuna cronologia chat ancora.",
    assistant_disclaimer: "Le risposte sono generate dall'IA, possono contenere errori e non costituiscono consulenza in materia di investimenti.",
    vip_save_title: "Salva come VIP",
    vip_save_desc: "Salva questo prompt come «Very Important Prompt» per riutilizzarlo rapidamente in seguito.",
    vip_prompt_label: "Prompt",
    vip_save_confirm: "Salva",
    vip_cancel: "Annulla",
    vip_saved_success: "Salvato come VIP.",
    vip_saved_error: "Salvataggio non riuscito. Riprova.",
    vip_delete_title: "Elimina VIP",
    vip_delete_desc: "Vuoi davvero eliminare questo prompt salvato? L'operazione non può essere annullata.",
    vip_delete_confirm: "Elimina",
    vip_deleted_success: "VIP eliminato.",
    vip_deleted_error: "Eliminazione non riuscita. Riprova.",
    file_loading: "Caricamento del report …",
    file_error_not_available: "Questo report non è al momento disponibile.",
    file_error_temporarily_unavailable: "Il report è temporaneamente non raggiungibile. Riprova più tardi.",
    file_error_rate_limited: "Troppe richieste di report in poco tempo. Riprova tra un momento.",
    file_error_upstream_misconfigured: "L'accesso a theScreener presenta attualmente dei problemi. Riprova più tardi.",
    file_error_bad_request: "Questo link al report non è valido. Richiedi di nuovo il report nell'assistente.",
    file_error_generic: "Non è stato possibile aprire il report. Riprova più tardi.",
  },
};
Object.keys(chatUiTranslations).forEach((lng) => {
  if (!resources[lng]) resources[lng] = { translation: {} };
  if (!resources[lng].translation) resources[lng].translation = {};
  Object.assign(resources[lng].translation, chatUiTranslations[lng]);
});

// ── HeyBro Insurance (company-dossier agent) — merged per language ──
// Dossiers are RESEARCHED and stored in German (shared library — see
// el-bank-backend/docs/heybro-insurance/README.md, "Sprachen") and translated
// for viewing by the backend. These keys are the chrome around that content;
// the live-run step labels and dossier field labels live in
// `heybroDossierTranslations` further down.
const heybroTranslations = {
  de: {
    heybro_insurance: "HeyBro Insurance",
    heybro_tab_assistant: "Assistent",
    heybro_tab_dossiers: "Dossiers",
    heybro_intro: "Ich erstelle quellenbasierte bKV-Company-Dossiers.\nNenne mir einfach eine Firma – zum Beispiel: „Erstelle ein Dossier für die Saarstahl AG“.\nIch kann außerdem bestehende Dossiers auflisten, öffnen, aktualisieren und löschen.",
    heybro_placeholder: "Firma nennen oder Frage stellen…",
    heybro_error: "Bei der Antwort ist ein Fehler aufgetreten. Bitte versuche es erneut.",
    heybro_disclaimer: "Die Dossier-Inhalte wurden von KI aus öffentlichen Quellen erstellt. Kontaktdaten und Funktionen vor Verwendung verifizieren; keine Rechtsberatung.",
    heybro_hero_collecting: "Company Intelligence wird aufgebaut…",
    heybro_hero_analyzing: "Erkenntnisse werden verdichtet…",
    heybro_hero_composing: "Dossier wird komponiert…",
    heybro_hero_subtitle: "Die Recherche läuft im Hintergrund – du kannst dieses Fenster offen lassen.",
    heybro_run_failed: "Recherche fehlgeschlagen",
    heybro_retry: "Erneut versuchen",
    heybro_back: "Zurück",
    heybro_list_empty: "Noch keine Dossiers vorhanden. Bitte den Assistenten, das erste zu erstellen – der Firmenname genügt.",
    heybro_status_planning: "in Vorbereitung",
    heybro_status_collecting: "Recherche läuft",
    heybro_status_analyzing: "Analyse läuft",
    heybro_status_composing: "wird komponiert",
    heybro_status_refreshing: "wird aktualisiert",
    heybro_status_ready: "fertig",
    heybro_status_error: "fehlgeschlagen",
    heybro_export: "Als Word-Dokument herunterladen",
    heybro_refresh: "Dossier aktualisieren",
    heybro_delete: "Dossier löschen",
    heybro_delete_title: "Dossier löschen",
    heybro_delete_desc: "Das Dossier für „{{company}}“ wirklich löschen? Es wird für ALLE Nutzer entfernt und kann nicht wiederhergestellt werden.",
    heybro_created_by: "Erstellt von",
    heybro_stand: "Stand",
    heybro_sources: "Quellen & Verifikation",
    heybro_copy: "Kopieren",
    heybro_copied: "Kopiert!",
    heybro_attractiveness: "Attraktivität",
    heybro_recommended_entry: "Empfohlener Einstieg",
    heybro_next_step: "Nächster Schritt",
    heybro_signals: "Signale",
    heybro_objections: "Erwartbare Einwände",
    heybro_final_recommendation: "Empfehlung",
    heybro_ch_overview: "Überblick",
    heybro_ch_people: "Ansprechpartner",
    heybro_ch_opportunity: "Anlässe & Bedarf",
    heybro_ch_playbook: "Gesprächsführung",
    heybro_ch_company: "Unternehmen",
    heybro_ch_plan: "Risiken & Plan",
    heybro_details: "Details",
    heybro_prio_a: "Priorität A — zuerst ansprechen",
    heybro_prio_b: "Priorität B — zweiter Kreis",
    heybro_prio_other: "Weitere Kontakte",
    heybro_sections_count: "Abschnitte",
    heybro_sources_count: "Quellen",
    heybro_more: "Mehr anzeigen",
    heybro_less: "Weniger anzeigen",
    heybro_open: "Öffnen",
  },
  en: {
    heybro_insurance: "HeyBro Insurance",
    heybro_tab_assistant: "Assistant",
    heybro_tab_dossiers: "Dossiers",
    heybro_intro: "I build source-based bKV company dossiers.\nJust name a company – for example: “Create a dossier for Saarstahl AG”.\nI can also list, open, refresh and delete existing dossiers.",
    heybro_placeholder: "Name a company or ask a question…",
    heybro_error: "Something went wrong with this reply. Please try again.",
    heybro_disclaimer: "Dossier content is AI-generated from public sources. Verify contact details and roles before use; not legal advice.",
    heybro_hero_collecting: "Building company intelligence…",
    heybro_hero_analyzing: "Condensing the findings…",
    heybro_hero_composing: "Composing the dossier…",
    heybro_hero_subtitle: "The research runs in the background – you can keep this window open.",
    heybro_run_failed: "Research failed",
    heybro_retry: "Try again",
    heybro_back: "Back",
    heybro_list_empty: "No dossiers yet. Ask the assistant to create the first one – a company name is all it needs.",
    heybro_status_planning: "preparing",
    heybro_status_collecting: "researching",
    heybro_status_analyzing: "analyzing",
    heybro_status_composing: "composing",
    heybro_status_refreshing: "refreshing",
    heybro_status_ready: "ready",
    heybro_status_error: "failed",
    heybro_export: "Download as Word document",
    heybro_refresh: "Refresh dossier",
    heybro_delete: "Delete dossier",
    heybro_delete_title: "Delete dossier",
    heybro_delete_desc: "Really delete the dossier for “{{company}}”? It will be removed for ALL users and cannot be restored.",
    heybro_created_by: "Created by",
    heybro_stand: "As of",
    heybro_sources: "Sources & verification",
    heybro_copy: "Copy",
    heybro_copied: "Copied!",
    heybro_attractiveness: "Attractiveness",
    heybro_recommended_entry: "Recommended entry",
    heybro_next_step: "Next step",
    heybro_signals: "Signals",
    heybro_objections: "Expected objections",
    heybro_final_recommendation: "Recommendation",
    heybro_ch_overview: "Overview",
    heybro_ch_people: "Contacts",
    heybro_ch_opportunity: "Signals & needs",
    heybro_ch_playbook: "Playbook",
    heybro_ch_company: "Company",
    heybro_ch_plan: "Risks & plan",
    heybro_details: "Details",
    heybro_prio_a: "Priority A — approach first",
    heybro_prio_b: "Priority B — second circle",
    heybro_prio_other: "Further contacts",
    heybro_sections_count: "sections",
    heybro_sources_count: "sources",
    heybro_more: "Show more",
    heybro_less: "Show less",
    heybro_open: "Open",
  },
  fr: {
    heybro_insurance: "HeyBro Insurance",
    heybro_tab_assistant: "Assistant",
    heybro_tab_dossiers: "Dossiers",
    heybro_intro: "Je crée des dossiers d'entreprise bKV basés sur des sources.\nIndiquez simplement une entreprise – par exemple : « Crée un dossier pour Saarstahl AG ».\nJe peux aussi lister, ouvrir, actualiser et supprimer les dossiers existants.",
    heybro_placeholder: "Nommer une entreprise ou poser une question…",
    heybro_error: "Une erreur s'est produite. Veuillez réessayer.",
    heybro_disclaimer: "Le contenu des dossiers est généré par IA à partir de sources publiques. Vérifiez les coordonnées et fonctions avant utilisation ; ceci ne constitue pas un conseil juridique.",
    heybro_hero_collecting: "Construction de la company intelligence…",
    heybro_hero_analyzing: "Condensation des résultats…",
    heybro_hero_composing: "Composition du dossier…",
    heybro_hero_subtitle: "La recherche s'exécute en arrière-plan – vous pouvez laisser cette fenêtre ouverte.",
    heybro_run_failed: "Échec de la recherche",
    heybro_retry: "Réessayer",
    heybro_back: "Retour",
    heybro_list_empty: "Aucun dossier pour le moment. Demandez à l'assistant d'en créer un – le nom de l'entreprise suffit.",
    heybro_status_planning: "en préparation",
    heybro_status_collecting: "recherche en cours",
    heybro_status_analyzing: "analyse en cours",
    heybro_status_composing: "composition",
    heybro_status_refreshing: "actualisation",
    heybro_status_ready: "terminé",
    heybro_status_error: "échoué",
    heybro_export: "Télécharger en document Word",
    heybro_refresh: "Actualiser le dossier",
    heybro_delete: "Supprimer le dossier",
    heybro_delete_title: "Supprimer le dossier",
    heybro_delete_desc: "Voulez-vous vraiment supprimer le dossier de « {{company}} » ? Il sera supprimé pour TOUS les utilisateurs et ne pourra pas être restauré.",
    heybro_created_by: "Créé par",
    heybro_stand: "État au",
    heybro_sources: "Sources & vérification",
    heybro_copy: "Copier",
    heybro_copied: "Copié !",
    heybro_attractiveness: "Attractivité",
    heybro_recommended_entry: "Entrée recommandée",
    heybro_next_step: "Prochaine étape",
    heybro_signals: "Signaux",
    heybro_objections: "Objections attendues",
    heybro_final_recommendation: "Recommandation",
    heybro_ch_overview: "Aperçu",
    heybro_ch_people: "Contacts",
    heybro_ch_opportunity: "Signaux & besoins",
    heybro_ch_playbook: "Approche",
    heybro_ch_company: "Entreprise",
    heybro_ch_plan: "Risques & plan",
    heybro_details: "Détails",
    heybro_prio_a: "Priorité A — à contacter en premier",
    heybro_prio_b: "Priorité B — deuxième cercle",
    heybro_prio_other: "Autres contacts",
    heybro_sections_count: "sections",
    heybro_sources_count: "sources",
    heybro_more: "Afficher plus",
    heybro_less: "Afficher moins",
    heybro_open: "Ouvrir",
  },
  es: {
    heybro_insurance: "HeyBro Insurance",
    heybro_tab_assistant: "Asistente",
    heybro_tab_dossiers: "Dossiers",
    heybro_intro: "Creo dossiers de empresas bKV basados en fuentes.\nSolo nombra una empresa – por ejemplo: «Crea un dossier para Saarstahl AG».\nTambién puedo listar, abrir, actualizar y eliminar dossiers existentes.",
    heybro_placeholder: "Nombra una empresa o haz una pregunta…",
    heybro_error: "Se produjo un error. Inténtalo de nuevo.",
    heybro_disclaimer: "El contenido de los dossiers se genera por IA a partir de fuentes públicas. Verifica contactos y cargos antes de usarlos; no constituye asesoramiento jurídico.",
    heybro_hero_collecting: "Construyendo company intelligence…",
    heybro_hero_analyzing: "Condensando los hallazgos…",
    heybro_hero_composing: "Componiendo el dossier…",
    heybro_hero_subtitle: "La investigación se ejecuta en segundo plano – puedes dejar esta ventana abierta.",
    heybro_run_failed: "La investigación falló",
    heybro_retry: "Reintentar",
    heybro_back: "Atrás",
    heybro_list_empty: "Aún no hay dossiers. Pide al asistente que cree el primero – basta con el nombre de la empresa.",
    heybro_status_planning: "en preparación",
    heybro_status_collecting: "investigando",
    heybro_status_analyzing: "analizando",
    heybro_status_composing: "componiendo",
    heybro_status_refreshing: "actualizando",
    heybro_status_ready: "listo",
    heybro_status_error: "fallido",
    heybro_export: "Descargar como documento Word",
    heybro_refresh: "Actualizar dossier",
    heybro_delete: "Eliminar dossier",
    heybro_delete_title: "Eliminar dossier",
    heybro_delete_desc: "¿Seguro que quieres eliminar el dossier de «{{company}}»? Se eliminará para TODOS los usuarios y no se puede restaurar.",
    heybro_created_by: "Creado por",
    heybro_stand: "A fecha de",
    heybro_sources: "Fuentes y verificación",
    heybro_copy: "Copiar",
    heybro_copied: "¡Copiado!",
    heybro_attractiveness: "Atractivo",
    heybro_recommended_entry: "Entrada recomendada",
    heybro_next_step: "Siguiente paso",
    heybro_signals: "Señales",
    heybro_objections: "Objeciones esperadas",
    heybro_final_recommendation: "Recomendación",
    heybro_ch_overview: "Resumen",
    heybro_ch_people: "Contactos",
    heybro_ch_opportunity: "Señales y necesidades",
    heybro_ch_playbook: "Estrategia",
    heybro_ch_company: "Empresa",
    heybro_ch_plan: "Riesgos y plan",
    heybro_details: "Detalles",
    heybro_prio_a: "Prioridad A — contactar primero",
    heybro_prio_b: "Prioridad B — segundo círculo",
    heybro_prio_other: "Otros contactos",
    heybro_sections_count: "secciones",
    heybro_sources_count: "fuentes",
    heybro_more: "Mostrar más",
    heybro_less: "Mostrar menos",
    heybro_open: "Abrir",
  },
  it: {
    heybro_insurance: "HeyBro Insurance",
    heybro_tab_assistant: "Assistente",
    heybro_tab_dossiers: "Dossier",
    heybro_intro: "Creo dossier aziendali bKV basati su fonti.\nBasta indicare un'azienda – ad esempio: «Crea un dossier per Saarstahl AG».\nPosso anche elencare, aprire, aggiornare ed eliminare i dossier esistenti.",
    heybro_placeholder: "Indica un'azienda o fai una domanda…",
    heybro_error: "Si è verificato un errore. Riprova.",
    heybro_disclaimer: "I contenuti dei dossier sono generati dall'IA da fonti pubbliche. Verifica contatti e ruoli prima dell'uso; non costituisce consulenza legale.",
    heybro_hero_collecting: "Costruzione della company intelligence…",
    heybro_hero_analyzing: "Condensazione dei risultati…",
    heybro_hero_composing: "Composizione del dossier…",
    heybro_hero_subtitle: "La ricerca è in esecuzione in background – puoi lasciare aperta questa finestra.",
    heybro_run_failed: "Ricerca non riuscita",
    heybro_retry: "Riprova",
    heybro_back: "Indietro",
    heybro_list_empty: "Nessun dossier ancora. Chiedi all'assistente di crearne uno – basta il nome dell'azienda.",
    heybro_status_planning: "in preparazione",
    heybro_status_collecting: "ricerca in corso",
    heybro_status_analyzing: "analisi in corso",
    heybro_status_composing: "composizione",
    heybro_status_refreshing: "aggiornamento",
    heybro_status_ready: "pronto",
    heybro_status_error: "non riuscito",
    heybro_export: "Scarica come documento Word",
    heybro_refresh: "Aggiorna dossier",
    heybro_delete: "Elimina dossier",
    heybro_delete_title: "Elimina dossier",
    heybro_delete_desc: "Vuoi davvero eliminare il dossier di «{{company}}»? Verrà rimosso per TUTTI gli utenti e non potrà essere ripristinato.",
    heybro_created_by: "Creato da",
    heybro_stand: "Aggiornato al",
    heybro_sources: "Fonti e verifica",
    heybro_copy: "Copia",
    heybro_copied: "Copiato!",
    heybro_attractiveness: "Attrattività",
    heybro_recommended_entry: "Ingresso consigliato",
    heybro_next_step: "Prossimo passo",
    heybro_signals: "Segnali",
    heybro_objections: "Obiezioni attese",
    heybro_final_recommendation: "Raccomandazione",
    heybro_ch_overview: "Panoramica",
    heybro_ch_people: "Contatti",
    heybro_ch_opportunity: "Segnali e bisogni",
    heybro_ch_playbook: "Strategia",
    heybro_ch_company: "Azienda",
    heybro_ch_plan: "Rischi e piano",
    heybro_details: "Dettagli",
    heybro_prio_a: "Priorità A — contattare per primi",
    heybro_prio_b: "Priorità B — secondo cerchio",
    heybro_prio_other: "Altri contatti",
    heybro_sections_count: "sezioni",
    heybro_sources_count: "fonti",
    heybro_more: "Mostra di più",
    heybro_less: "Mostra meno",
    heybro_open: "Apri",
  },
};
// ── HeyBro Insurance — live-run steps + dossier field labels ──────────────
// The research pipeline writes German step labels into company_dossiers.
// progress; every step also carries a stable `key` (src/dossier_agent/
// pipeline.py) which maps to `heybro_step_<key>` here, so the live radar
// switches language instantly with the UI. The backend label stays as the
// fallback for rows written before keys existed.
//
// The field labels below were hardcoded German inside DossierView. Dossier
// CONTENT is researched in German and translated on view by the backend
// (src/dossier_agent/translate.py); the enum values it deliberately keeps
// canonical ('bestaetigt', 'hoch', …) are given their display label here.
const heybroDossierTranslations = {
  de: {
    heybro_translating: "Dossier wird in deine Sprache übersetzt…",
    heybro_step_basis: "Unternehmen identifizieren",
    heybro_step_compose: "Dossier komponieren",
    heybro_step_track_kennzahlen: "Kennzahlen & Geschäftsbericht",
    heybro_step_track_entscheider: "Vorstand & HR-Entscheider",
    heybro_step_track_belegschaft: "Standorte & Belegschaft",
    heybro_step_track_betriebsrat: "Betriebsrat & BR-Wahl",
    heybro_step_track_vertretungen: "JAV, SBV & Aufsichtsrat",
    heybro_step_track_gewerkschaft: "Gewerkschaft & Geschäftsstelle",
    heybro_step_track_tarif: "Tarif- & Betriebsthemen",
    heybro_step_track_benefits: "Benefits & Gesundheitsangebote",
    heybro_step_track_signale: "Vertriebs- & Veränderungssignale",
    heybro_step_track_wettbewerb: "Wettbewerb & Vergleichsarbeitgeber",
    heybro_step_track_risiken: "Risiken & Reputation",
    heybro_step_section_contacts: "Priorisierte Ansprechpartner",
    heybro_step_section_approach: "Empfohlene Anspracheabfolge",
    heybro_step_section_buying_center: "Buying Center & Machtstruktur",
    heybro_step_section_tarif_themen: "Aktuelle tarifliche und betriebliche Themen",
    heybro_step_section_hypotheses: "Bedarfshypothesen",
    heybro_step_section_outreach: "Gesprächsstrategie & Ansprache-Vorlagen",
    heybro_step_section_mitbestimmung: "Mitbestimmung, Datenschutz & Umsetzung",
    heybro_step_section_profile: "Unternehmens- und Belegschaftskontext",
    heybro_step_section_benefits: "Bestehende Benefits & Gesundheitsangebote",
    heybro_step_section_competition: "Wettbewerb & Vergleichsarbeitgeber",
    heybro_step_section_risks: "Risiken und sensible Punkte",
    heybro_step_section_action_plan: "Aktionsplan: 7 / 30 / 90 Tage",
    heybro_v_bestaetigt: "bestätigt",
    heybro_v_wahrscheinlich: "wahrscheinlich",
    heybro_v_historisch: "historisch",
    heybro_v_nicht_verifiziert: "nicht verifiziert",
    heybro_lvl_hoch: "hoch",
    heybro_lvl_mittel: "mittel",
    heybro_lvl_niedrig: "niedrig",
    heybro_cockpit: "Berater-Cockpit",
    heybro_f_opener: "Gesprächseinstieg",
    heybro_f_influence: "Einfluss & Relevanz",
    heybro_f_channel: "Kontaktweg",
    heybro_f_source_date: "Quelle & Stand",
    heybro_f_need: "Möglicher Bedarf",
    heybro_f_target_person: "Ansprechpartner",
    heybro_f_benefit: "Nutzen",
    heybro_f_check_question: "Prüffrage",
    heybro_f_objection: "Erwartbarer Einwand",
    heybro_f_answer: "Empfohlene Antwort",
    heybro_f_impact: "Bedeutung",
    heybro_f_actors: "Betroffene Akteure",
    heybro_f_reaction: "Mögliche Reaktion",
    heybro_f_recommendation: "Empfehlung",
    heybro_success_criteria: "Erfolgskriterien",
    heybro_abort_criteria: "Abbruch-/Rückstellungskriterien",
    heybro_rec_who: "Wen zuerst ansprechen?",
    heybro_rec_channel: "Über welchen Kontaktweg?",
    heybro_rec_occasion: "Mit welchem Anlass?",
    heybro_rec_goal: "Ziel des ersten Gesprächs",
  },
  en: {
    heybro_translating: "Translating the dossier into your language…",
    heybro_step_basis: "Identifying the company",
    heybro_step_compose: "Composing the dossier",
    heybro_step_track_kennzahlen: "Key figures & annual report",
    heybro_step_track_entscheider: "Board & HR decision-makers",
    heybro_step_track_belegschaft: "Sites & workforce",
    heybro_step_track_betriebsrat: "Works council & elections",
    heybro_step_track_vertretungen: "JAV, SBV & supervisory board",
    heybro_step_track_gewerkschaft: "Union & local office",
    heybro_step_track_tarif: "Collective bargaining & workplace topics",
    heybro_step_track_benefits: "Benefits & health offerings",
    heybro_step_track_signale: "Sales & change signals",
    heybro_step_track_wettbewerb: "Competitors & peer employers",
    heybro_step_track_risiken: "Risks & reputation",
    heybro_step_section_contacts: "Prioritised contacts",
    heybro_step_section_approach: "Recommended approach sequence",
    heybro_step_section_buying_center: "Buying center & power structure",
    heybro_step_section_tarif_themen: "Current bargaining & workplace topics",
    heybro_step_section_hypotheses: "Need hypotheses",
    heybro_step_section_outreach: "Conversation strategy & outreach templates",
    heybro_step_section_mitbestimmung: "Codetermination, data protection & rollout",
    heybro_step_section_profile: "Company & workforce context",
    heybro_step_section_benefits: "Existing benefits & health offerings",
    heybro_step_section_competition: "Competitors & peer employers",
    heybro_step_section_risks: "Risks & sensitive points",
    heybro_step_section_action_plan: "Action plan: 7 / 30 / 90 days",
    heybro_v_bestaetigt: "confirmed",
    heybro_v_wahrscheinlich: "likely",
    heybro_v_historisch: "historical",
    heybro_v_nicht_verifiziert: "unverified",
    heybro_lvl_hoch: "high",
    heybro_lvl_mittel: "medium",
    heybro_lvl_niedrig: "low",
    heybro_cockpit: "Advisor cockpit",
    heybro_f_opener: "Conversation opener",
    heybro_f_influence: "Influence & relevance",
    heybro_f_channel: "Contact channel",
    heybro_f_source_date: "Source & status",
    heybro_f_need: "Possible need",
    heybro_f_target_person: "Contact person",
    heybro_f_benefit: "Benefit",
    heybro_f_check_question: "Qualifying question",
    heybro_f_objection: "Expected objection",
    heybro_f_answer: "Recommended answer",
    heybro_f_impact: "Significance",
    heybro_f_actors: "Affected parties",
    heybro_f_reaction: "Possible reaction",
    heybro_f_recommendation: "Recommendation",
    heybro_success_criteria: "Success criteria",
    heybro_abort_criteria: "Abort / hold criteria",
    heybro_rec_who: "Who to approach first?",
    heybro_rec_channel: "Through which channel?",
    heybro_rec_occasion: "On what occasion?",
    heybro_rec_goal: "Goal of the first conversation",
  },
  fr: {
    heybro_translating: "Traduction du dossier dans votre langue…",
    heybro_step_basis: "Identification de l'entreprise",
    heybro_step_compose: "Composition du dossier",
    heybro_step_track_kennzahlen: "Chiffres clés et rapport annuel",
    heybro_step_track_entscheider: "Direction et décideurs RH",
    heybro_step_track_belegschaft: "Sites et effectifs",
    heybro_step_track_betriebsrat: "Comité d'entreprise et élections",
    heybro_step_track_vertretungen: "JAV, SBV et conseil de surveillance",
    heybro_step_track_gewerkschaft: "Syndicat et antenne locale",
    heybro_step_track_tarif: "Négociations collectives et sujets internes",
    heybro_step_track_benefits: "Avantages et offres santé",
    heybro_step_track_signale: "Signaux commerciaux et de changement",
    heybro_step_track_wettbewerb: "Concurrence et employeurs comparables",
    heybro_step_track_risiken: "Risques et réputation",
    heybro_step_section_contacts: "Interlocuteurs prioritaires",
    heybro_step_section_approach: "Séquence d'approche recommandée",
    heybro_step_section_buying_center: "Centre de décision et structure de pouvoir",
    heybro_step_section_tarif_themen: "Sujets conventionnels et internes actuels",
    heybro_step_section_hypotheses: "Hypothèses de besoins",
    heybro_step_section_outreach: "Stratégie d'entretien et modèles d'approche",
    heybro_step_section_mitbestimmung: "Cogestion, protection des données et mise en œuvre",
    heybro_step_section_profile: "Contexte de l'entreprise et des effectifs",
    heybro_step_section_benefits: "Avantages et offres santé existants",
    heybro_step_section_competition: "Concurrence et employeurs comparables",
    heybro_step_section_risks: "Risques et points sensibles",
    heybro_step_section_action_plan: "Plan d'action : 7 / 30 / 90 jours",
    heybro_v_bestaetigt: "confirmé",
    heybro_v_wahrscheinlich: "probable",
    heybro_v_historisch: "historique",
    heybro_v_nicht_verifiziert: "non vérifié",
    heybro_lvl_hoch: "élevé",
    heybro_lvl_mittel: "moyen",
    heybro_lvl_niedrig: "faible",
    heybro_cockpit: "Cockpit du conseiller",
    heybro_f_opener: "Accroche d'entretien",
    heybro_f_influence: "Influence & pertinence",
    heybro_f_channel: "Canal de contact",
    heybro_f_source_date: "Source & état",
    heybro_f_need: "Besoin possible",
    heybro_f_target_person: "Interlocuteur",
    heybro_f_benefit: "Bénéfice",
    heybro_f_check_question: "Question de qualification",
    heybro_f_objection: "Objection attendue",
    heybro_f_answer: "Réponse recommandée",
    heybro_f_impact: "Portée",
    heybro_f_actors: "Acteurs concernés",
    heybro_f_reaction: "Réaction possible",
    heybro_f_recommendation: "Recommandation",
    heybro_success_criteria: "Critères de réussite",
    heybro_abort_criteria: "Critères d'arrêt / de report",
    heybro_rec_who: "Qui contacter en premier ?",
    heybro_rec_channel: "Par quel canal ?",
    heybro_rec_occasion: "À quelle occasion ?",
    heybro_rec_goal: "Objectif du premier entretien",
  },
  es: {
    heybro_translating: "Traduciendo el dossier a tu idioma…",
    heybro_step_basis: "Identificación de la empresa",
    heybro_step_compose: "Composición del dossier",
    heybro_step_track_kennzahlen: "Cifras clave e informe anual",
    heybro_step_track_entscheider: "Dirección y responsables de RR. HH.",
    heybro_step_track_belegschaft: "Centros y plantilla",
    heybro_step_track_betriebsrat: "Comité de empresa y elecciones",
    heybro_step_track_vertretungen: "JAV, SBV y consejo de vigilancia",
    heybro_step_track_gewerkschaft: "Sindicato y oficina local",
    heybro_step_track_tarif: "Negociación colectiva y temas internos",
    heybro_step_track_benefits: "Beneficios y servicios de salud",
    heybro_step_track_signale: "Señales comerciales y de cambio",
    heybro_step_track_wettbewerb: "Competencia y empleadores comparables",
    heybro_step_track_risiken: "Riesgos y reputación",
    heybro_step_section_contacts: "Contactos priorizados",
    heybro_step_section_approach: "Secuencia de contacto recomendada",
    heybro_step_section_buying_center: "Centro de decisión y estructura de poder",
    heybro_step_section_tarif_themen: "Temas actuales de convenio y empresa",
    heybro_step_section_hypotheses: "Hipótesis de necesidades",
    heybro_step_section_outreach: "Estrategia de conversación y plantillas",
    heybro_step_section_mitbestimmung: "Cogestión, protección de datos e implantación",
    heybro_step_section_profile: "Contexto de empresa y plantilla",
    heybro_step_section_benefits: "Beneficios y servicios de salud existentes",
    heybro_step_section_competition: "Competencia y empleadores comparables",
    heybro_step_section_risks: "Riesgos y puntos sensibles",
    heybro_step_section_action_plan: "Plan de acción: 7 / 30 / 90 días",
    heybro_v_bestaetigt: "confirmado",
    heybro_v_wahrscheinlich: "probable",
    heybro_v_historisch: "histórico",
    heybro_v_nicht_verifiziert: "no verificado",
    heybro_lvl_hoch: "alto",
    heybro_lvl_mittel: "medio",
    heybro_lvl_niedrig: "bajo",
    heybro_cockpit: "Cockpit del asesor",
    heybro_f_opener: "Apertura de conversación",
    heybro_f_influence: "Influencia y relevancia",
    heybro_f_channel: "Canal de contacto",
    heybro_f_source_date: "Fuente y estado",
    heybro_f_need: "Posible necesidad",
    heybro_f_target_person: "Persona de contacto",
    heybro_f_benefit: "Beneficio",
    heybro_f_check_question: "Pregunta de calificación",
    heybro_f_objection: "Objeción esperada",
    heybro_f_answer: "Respuesta recomendada",
    heybro_f_impact: "Relevancia",
    heybro_f_actors: "Partes afectadas",
    heybro_f_reaction: "Posible reacción",
    heybro_f_recommendation: "Recomendación",
    heybro_success_criteria: "Criterios de éxito",
    heybro_abort_criteria: "Criterios de abandono / aplazamiento",
    heybro_rec_who: "¿A quién contactar primero?",
    heybro_rec_channel: "¿Por qué canal?",
    heybro_rec_occasion: "¿Con qué motivo?",
    heybro_rec_goal: "Objetivo de la primera conversación",
  },
  it: {
    heybro_translating: "Traduzione del dossier nella tua lingua…",
    heybro_step_basis: "Identificazione dell'azienda",
    heybro_step_compose: "Composizione del dossier",
    heybro_step_track_kennzahlen: "Dati chiave e bilancio",
    heybro_step_track_entscheider: "Vertici e decisori HR",
    heybro_step_track_belegschaft: "Sedi e organico",
    heybro_step_track_betriebsrat: "Consiglio aziendale ed elezioni",
    heybro_step_track_vertretungen: "JAV, SBV e consiglio di sorveglianza",
    heybro_step_track_gewerkschaft: "Sindacato e sede locale",
    heybro_step_track_tarif: "Contrattazione collettiva e temi aziendali",
    heybro_step_track_benefits: "Benefit e offerte sanitarie",
    heybro_step_track_signale: "Segnali commerciali e di cambiamento",
    heybro_step_track_wettbewerb: "Concorrenza e datori di lavoro comparabili",
    heybro_step_track_risiken: "Rischi e reputazione",
    heybro_step_section_contacts: "Referenti prioritari",
    heybro_step_section_approach: "Sequenza di contatto consigliata",
    heybro_step_section_buying_center: "Centro decisionale e struttura di potere",
    heybro_step_section_tarif_themen: "Temi contrattuali e aziendali attuali",
    heybro_step_section_hypotheses: "Ipotesi di fabbisogno",
    heybro_step_section_outreach: "Strategia di colloquio e modelli di contatto",
    heybro_step_section_mitbestimmung: "Cogestione, protezione dei dati e attuazione",
    heybro_step_section_profile: "Contesto aziendale e organico",
    heybro_step_section_benefits: "Benefit e offerte sanitarie esistenti",
    heybro_step_section_competition: "Concorrenza e datori di lavoro comparabili",
    heybro_step_section_risks: "Rischi e punti sensibili",
    heybro_step_section_action_plan: "Piano d'azione: 7 / 30 / 90 giorni",
    heybro_v_bestaetigt: "confermato",
    heybro_v_wahrscheinlich: "probabile",
    heybro_v_historisch: "storico",
    heybro_v_nicht_verifiziert: "non verificato",
    heybro_lvl_hoch: "alto",
    heybro_lvl_mittel: "medio",
    heybro_lvl_niedrig: "basso",
    heybro_cockpit: "Cockpit del consulente",
    heybro_f_opener: "Apertura del colloquio",
    heybro_f_influence: "Influenza e rilevanza",
    heybro_f_channel: "Canale di contatto",
    heybro_f_source_date: "Fonte e stato",
    heybro_f_need: "Possibile fabbisogno",
    heybro_f_target_person: "Referente",
    heybro_f_benefit: "Beneficio",
    heybro_f_check_question: "Domanda di qualifica",
    heybro_f_objection: "Obiezione attesa",
    heybro_f_answer: "Risposta consigliata",
    heybro_f_impact: "Rilevanza",
    heybro_f_actors: "Soggetti coinvolti",
    heybro_f_reaction: "Possibile reazione",
    heybro_f_recommendation: "Raccomandazione",
    heybro_success_criteria: "Criteri di successo",
    heybro_abort_criteria: "Criteri di interruzione / rinvio",
    heybro_rec_who: "Chi contattare per primo?",
    heybro_rec_channel: "Attraverso quale canale?",
    heybro_rec_occasion: "In quale occasione?",
    heybro_rec_goal: "Obiettivo del primo colloquio",
  },
};

Object.keys(heybroTranslations).forEach((lng) => {
  if (!resources[lng]) resources[lng] = { translation: {} };
  if (!resources[lng].translation) resources[lng].translation = {};
  Object.assign(resources[lng].translation, heybroTranslations[lng],
    heybroDossierTranslations[lng] || {});
});

// ── Own audio cards (src/audio/) — the circles on the home screen, built with
// Bro by speech or in a form. Block, length and schedule labels come from the
// server's catalogue (src/audio_cards/catalog.py) in the UI language.
const audioCardTranslations = {
  de: {
    audio_section: "Deine Audios", audio_edit: "Bearbeiten", audio_done: "Fertig",
    audio_new: "Neues Audio", audio_new_sub: "sprechen oder tippen", audio_new_dot: "Neu vorbereitet",
    audio_hint: "Tippe auf ein Audio zum Anhören oder Ändern. Neues Audio: einmal reinsprechen, Bro baut es.",
    audio_hint_edit: "Tippe auf ein Audio, um es zu ändern, ✕ löscht es. Ziehen zum Sortieren.",
    audio_no_data: "Für Audios ist dir noch kein Datenbereich zugewiesen. Bitte wende dich an einen Administrator.",
    audio_saved_new: "„{{name}}“ ist gespeichert — du findest es hier bei deinen Audios.",
    audio_saved_changed: "Änderungen an „{{name}}“ gespeichert.",
    audio_deleted: "„{{name}}“ gelöscht", audio_undo: "Rückgängig",
    audio_new_title: "Neues Audio", audio_edit_title: "„{{name}}“ bearbeiten",
    audio_talk_to_bro: "Mit Bro sprechen",
    audio_builder_intro: "Stell dein Audio hier selbst zusammen — oder sag Bro einfach, was du hören willst.",
    audio_field_name: "Name", audio_field_model: "Datenbereich", audio_field_scope: "Thema", audio_field_blocks: "Inhalt",
    audio_field_length: "Länge", audio_field_schedule: "Wann", audio_field_preview: "Probehören",
    audio_name_placeholder: "Bro schlägt einen Namen vor",
    audio_model_efd: "EFD · Bank und Berater", audio_model_ppi: "PPI · Portfolios",
    audio_scope_book: "Mein Bereich", audio_scope_client: "Ein Kunde", audio_scope_area: "Eine Konsolidierung",
    audio_client_placeholder: "Kunde wählen",
    audio_blocks_empty: "Noch leer — sag Bro, was rein soll, oder füge ein Thema hinzu.",
    audio_option_cycle: "Antippen zum Wechseln", audio_move_up: "Nach oben", audio_remove: "Entfernen",
    audio_add_block: "Thema", audio_block_used: "schon drin", audio_block_book_only: "nicht bei einem einzelnen Kunden",
    audio_preview_button: "Probe anhören", audio_save: "Speichern", audio_save_changes: "Änderungen speichern",
    audio_missing: "Es fehlt noch: {{fields}}",
    audio_quick_shorter: "Mach es kürzer", audio_quick_longer: "Mach es ausführlicher",
    audio_quick_weekly: "Lieber nur montags", audio_quick_daily: "Lieber jeden Morgen", audio_quick_play: "Spiel mal ab",
    audio_example_efd_1: "Jeden Morgen ein kurzes Briefing mit Neugeld und meinen grössten Kunden",
    audio_example_efd_2: "Montags ausführlich: Vermögen, Ertrag und Neukunden",
    audio_example_ppi: "Jeden Morgen Performance und Allokation, kurz",
    audio_voice_greeting: "Hi! Was möchtest du hören? Sag mir einfach, worum es gehen soll, was rein soll und wann du es willst.",
    audio_voice_greeting_edit: "Was möchtest du an „{{name}}“ ändern?",
    audio_voice_thinking: "Einen Moment, ich baue dein Audio …", audio_voice_preview: "Ich schreibe deine Probe …",
    audio_voice_type: "Kein Mikrofon — tippe deine Antwort unten ein.",
    audio_voice_tap: "Tippe auf den Kreis, um weiterzusprechen.",
    audio_voice_type_placeholder: "… oder hier tippen",
    audio_progress: "Audio {{done}} / {{total}} — als Nächstes: {{next}}",
    audio_progress_complete: "Audio vollständig — sag „spiel ab“ oder „speichern“",
    audio_prepared_at: "Heute um {{time}} vorbereitet", audio_no_voice: "Vorlesen gerade nicht möglich — der Text steht unter dem Dokument-Symbol.",
    audio_change_with_bro: "Mit Bro ändern", audio_change_by_hand: "Selbst bearbeiten", audio_delete: "Löschen",
  },
  en: {
    audio_section: "Your audios", audio_edit: "Edit", audio_done: "Done",
    audio_new: "New audio", audio_new_sub: "speak or type", audio_new_dot: "Newly prepared",
    audio_hint: "Tap an audio to listen or change it. New audio: say it once, Bro builds it.",
    audio_hint_edit: "Tap an audio to change it, ✕ deletes it. Drag to reorder.",
    audio_no_data: "No data area is assigned to you for audios yet. Please contact an administrator.",
    audio_saved_new: "“{{name}}” is saved — you'll find it here with your audios.",
    audio_saved_changed: "Changes to “{{name}}” saved.",
    audio_deleted: "“{{name}}” deleted", audio_undo: "Undo",
    audio_new_title: "New audio", audio_edit_title: "Edit “{{name}}”",
    audio_talk_to_bro: "Talk to Bro",
    audio_builder_intro: "Put your audio together here — or just tell Bro what you want to hear.",
    audio_field_name: "Name", audio_field_model: "Data area", audio_field_scope: "Topic", audio_field_blocks: "Content",
    audio_field_length: "Length", audio_field_schedule: "When", audio_field_preview: "Preview",
    audio_name_placeholder: "Bro suggests a name",
    audio_model_efd: "EFD · bank and advisors", audio_model_ppi: "PPI · portfolios",
    audio_scope_book: "My area", audio_scope_client: "One client", audio_scope_area: "One consolidation",
    audio_client_placeholder: "Choose a client",
    audio_blocks_empty: "Still empty — tell Bro what should go in, or add a topic.",
    audio_option_cycle: "Tap to switch", audio_move_up: "Move up", audio_remove: "Remove",
    audio_add_block: "Topic", audio_block_used: "already in", audio_block_book_only: "not for a single client",
    audio_preview_button: "Play a preview", audio_save: "Save", audio_save_changes: "Save changes",
    audio_missing: "Still missing: {{fields}}",
    audio_quick_shorter: "Make it shorter", audio_quick_longer: "Make it longer",
    audio_quick_weekly: "Mondays only", audio_quick_daily: "Every morning instead", audio_quick_play: "Play it",
    audio_example_efd_1: "Every morning a short briefing on net new money and my largest clients",
    audio_example_efd_2: "On Mondays in detail: assets, income and new clients",
    audio_example_ppi: "Every morning performance and allocation, short",
    audio_voice_greeting: "Hi! What would you like to hear? Just tell me what it's about, what goes in and when you want it.",
    audio_voice_greeting_edit: "What would you like to change about “{{name}}”?",
    audio_voice_thinking: "One moment, I'm building your audio …", audio_voice_preview: "I'm writing your preview …",
    audio_voice_type: "No microphone — type your answer below.",
    audio_voice_tap: "Tap the circle to keep talking.",
    audio_voice_type_placeholder: "… or type here",
    audio_progress: "Audio {{done}} / {{total}} — next: {{next}}",
    audio_progress_complete: "Audio complete — say “play it” or “save”",
    audio_prepared_at: "Prepared today at {{time}}", audio_no_voice: "Voice not available right now — the text is under the document icon.",
    audio_change_with_bro: "Change with Bro", audio_change_by_hand: "Edit myself", audio_delete: "Delete",
  },
  fr: {
    audio_section: "Tes audios", audio_edit: "Modifier", audio_done: "Terminé",
    audio_new: "Nouvel audio", audio_new_sub: "parler ou écrire", audio_new_dot: "Nouvellement préparé",
    audio_hint: "Touche un audio pour l'écouter ou le modifier. Nouvel audio : dis-le une fois, Bro le crée.",
    audio_hint_edit: "Touche un audio pour le modifier, ✕ le supprime. Glisse pour réordonner.",
    audio_no_data: "Aucun périmètre de données ne t'est encore attribué pour les audios. Contacte un administrateur.",
    audio_saved_new: "« {{name}} » est enregistré — tu le trouves ici avec tes audios.",
    audio_saved_changed: "Modifications de « {{name}} » enregistrées.",
    audio_deleted: "« {{name}} » supprimé", audio_undo: "Annuler",
    audio_new_title: "Nouvel audio", audio_edit_title: "Modifier « {{name}} »",
    audio_talk_to_bro: "Parler à Bro",
    audio_builder_intro: "Compose ton audio ici — ou dis simplement à Bro ce que tu veux entendre.",
    audio_field_name: "Nom", audio_field_model: "Périmètre", audio_field_scope: "Sujet", audio_field_blocks: "Contenu",
    audio_field_length: "Durée", audio_field_schedule: "Quand", audio_field_preview: "Écouter un aperçu",
    audio_name_placeholder: "Bro propose un nom",
    audio_model_efd: "EFD · banque et conseillers", audio_model_ppi: "PPI · portefeuilles",
    audio_scope_book: "Mon périmètre", audio_scope_client: "Un client", audio_scope_area: "Une consolidation",
    audio_client_placeholder: "Choisir un client",
    audio_blocks_empty: "Encore vide — dis à Bro ce qu'il faut ajouter, ou ajoute un sujet.",
    audio_option_cycle: "Toucher pour changer", audio_move_up: "Monter", audio_remove: "Retirer",
    audio_add_block: "Sujet", audio_block_used: "déjà inclus", audio_block_book_only: "pas pour un seul client",
    audio_preview_button: "Écouter un aperçu", audio_save: "Enregistrer", audio_save_changes: "Enregistrer les modifications",
    audio_missing: "Il manque encore : {{fields}}",
    audio_quick_shorter: "Plus court", audio_quick_longer: "Plus détaillé",
    audio_quick_weekly: "Plutôt le lundi", audio_quick_daily: "Plutôt chaque matin", audio_quick_play: "Fais-le écouter",
    audio_example_efd_1: "Chaque matin un bref point sur l'argent frais et mes plus grands clients",
    audio_example_efd_2: "Le lundi en détail : avoirs, revenus et nouveaux clients",
    audio_example_ppi: "Chaque matin la performance et l'allocation, en bref",
    audio_voice_greeting: "Salut ! Qu'aimerais-tu entendre ? Dis-moi simplement le sujet, le contenu et quand tu le veux.",
    audio_voice_greeting_edit: "Que veux-tu changer à « {{name}} » ?",
    audio_voice_thinking: "Un instant, je prépare ton audio …", audio_voice_preview: "J'écris ton aperçu …",
    audio_voice_type: "Pas de microphone — écris ta réponse ci-dessous.",
    audio_voice_tap: "Touche le cercle pour continuer à parler.",
    audio_voice_type_placeholder: "… ou écris ici",
    audio_progress: "Audio {{done}} / {{total}} — ensuite : {{next}}",
    audio_progress_complete: "Audio complet — dis « fais écouter » ou « enregistrer »",
    audio_prepared_at: "Préparé aujourd'hui à {{time}}", audio_no_voice: "Lecture vocale indisponible — le texte est sous l'icône document.",
    audio_change_with_bro: "Modifier avec Bro", audio_change_by_hand: "Modifier moi-même", audio_delete: "Supprimer",
  },
  es: {
    audio_section: "Tus audios", audio_edit: "Editar", audio_done: "Listo",
    audio_new: "Nuevo audio", audio_new_sub: "hablar o escribir", audio_new_dot: "Recién preparado",
    audio_hint: "Toca un audio para escucharlo o cambiarlo. Nuevo audio: dilo una vez y Bro lo crea.",
    audio_hint_edit: "Toca un audio para cambiarlo, ✕ lo elimina. Arrastra para ordenar.",
    audio_no_data: "Todavía no tienes un ámbito de datos asignado para audios. Contacta con un administrador.",
    audio_saved_new: "«{{name}}» está guardado — lo encuentras aquí con tus audios.",
    audio_saved_changed: "Cambios en «{{name}}» guardados.",
    audio_deleted: "«{{name}}» eliminado", audio_undo: "Deshacer",
    audio_new_title: "Nuevo audio", audio_edit_title: "Editar «{{name}}»",
    audio_talk_to_bro: "Hablar con Bro",
    audio_builder_intro: "Arma tu audio aquí — o dile a Bro qué quieres escuchar.",
    audio_field_name: "Nombre", audio_field_model: "Ámbito de datos", audio_field_scope: "Tema", audio_field_blocks: "Contenido",
    audio_field_length: "Duración", audio_field_schedule: "Cuándo", audio_field_preview: "Escuchar una prueba",
    audio_name_placeholder: "Bro sugiere un nombre",
    audio_model_efd: "EFD · banco y asesores", audio_model_ppi: "PPI · carteras",
    audio_scope_book: "Mi ámbito", audio_scope_client: "Un cliente", audio_scope_area: "Una consolidación",
    audio_client_placeholder: "Elegir cliente",
    audio_blocks_empty: "Aún vacío — dile a Bro qué debe incluir o añade un tema.",
    audio_option_cycle: "Toca para cambiar", audio_move_up: "Subir", audio_remove: "Quitar",
    audio_add_block: "Tema", audio_block_used: "ya incluido", audio_block_book_only: "no para un solo cliente",
    audio_preview_button: "Escuchar una prueba", audio_save: "Guardar", audio_save_changes: "Guardar cambios",
    audio_missing: "Falta todavía: {{fields}}",
    audio_quick_shorter: "Más corto", audio_quick_longer: "Más detallado",
    audio_quick_weekly: "Mejor solo los lunes", audio_quick_daily: "Mejor cada mañana", audio_quick_play: "Reprodúcelo",
    audio_example_efd_1: "Cada mañana un resumen breve con nuevo dinero y mis mayores clientes",
    audio_example_efd_2: "Los lunes en detalle: patrimonio, ingresos y clientes nuevos",
    audio_example_ppi: "Cada mañana rentabilidad y asignación, breve",
    audio_voice_greeting: "¡Hola! ¿Qué te gustaría escuchar? Dime de qué trata, qué incluir y cuándo lo quieres.",
    audio_voice_greeting_edit: "¿Qué quieres cambiar en «{{name}}»?",
    audio_voice_thinking: "Un momento, preparo tu audio …", audio_voice_preview: "Escribo tu prueba …",
    audio_voice_type: "Sin micrófono — escribe tu respuesta abajo.",
    audio_voice_tap: "Toca el círculo para seguir hablando.",
    audio_voice_type_placeholder: "… o escribe aquí",
    audio_progress: "Audio {{done}} / {{total}} — siguiente: {{next}}",
    audio_progress_complete: "Audio completo — di «reprodúcelo» o «guardar»",
    audio_prepared_at: "Preparado hoy a las {{time}}", audio_no_voice: "Voz no disponible ahora — el texto está bajo el icono de documento.",
    audio_change_with_bro: "Cambiar con Bro", audio_change_by_hand: "Editar yo mismo", audio_delete: "Eliminar",
  },
  it: {
    audio_section: "I tuoi audio", audio_edit: "Modifica", audio_done: "Fatto",
    audio_new: "Nuovo audio", audio_new_sub: "parla o scrivi", audio_new_dot: "Appena preparato",
    audio_hint: "Tocca un audio per ascoltarlo o modificarlo. Nuovo audio: dillo una volta, Bro lo crea.",
    audio_hint_edit: "Tocca un audio per modificarlo, ✕ lo elimina. Trascina per riordinare.",
    audio_no_data: "Non hai ancora un'area dati assegnata per gli audio. Contatta un amministratore.",
    audio_saved_new: "«{{name}}» è salvato — lo trovi qui tra i tuoi audio.",
    audio_saved_changed: "Modifiche a «{{name}}» salvate.",
    audio_deleted: "«{{name}}» eliminato", audio_undo: "Annulla",
    audio_new_title: "Nuovo audio", audio_edit_title: "Modifica «{{name}}»",
    audio_talk_to_bro: "Parla con Bro",
    audio_builder_intro: "Componi qui il tuo audio — oppure di' semplicemente a Bro cosa vuoi ascoltare.",
    audio_field_name: "Nome", audio_field_model: "Area dati", audio_field_scope: "Tema", audio_field_blocks: "Contenuto",
    audio_field_length: "Durata", audio_field_schedule: "Quando", audio_field_preview: "Ascolta un'anteprima",
    audio_name_placeholder: "Bro propone un nome",
    audio_model_efd: "EFD · banca e consulenti", audio_model_ppi: "PPI · portafogli",
    audio_scope_book: "La mia area", audio_scope_client: "Un cliente", audio_scope_area: "Un consolidamento",
    audio_client_placeholder: "Scegli un cliente",
    audio_blocks_empty: "Ancora vuoto — di' a Bro cosa inserire o aggiungi un tema.",
    audio_option_cycle: "Tocca per cambiare", audio_move_up: "Sposta su", audio_remove: "Rimuovi",
    audio_add_block: "Tema", audio_block_used: "già incluso", audio_block_book_only: "non per un singolo cliente",
    audio_preview_button: "Ascolta un'anteprima", audio_save: "Salva", audio_save_changes: "Salva modifiche",
    audio_missing: "Manca ancora: {{fields}}",
    audio_quick_shorter: "Più breve", audio_quick_longer: "Più dettagliato",
    audio_quick_weekly: "Meglio solo il lunedì", audio_quick_daily: "Meglio ogni mattina", audio_quick_play: "Fammelo sentire",
    audio_example_efd_1: "Ogni mattina un breve briefing sulla nuova raccolta e i miei clienti più grandi",
    audio_example_efd_2: "Il lunedì in dettaglio: patrimonio, ricavi e nuovi clienti",
    audio_example_ppi: "Ogni mattina performance e allocazione, in breve",
    audio_voice_greeting: "Ciao! Cosa vorresti ascoltare? Dimmi di cosa si tratta, cosa includere e quando lo vuoi.",
    audio_voice_greeting_edit: "Cosa vuoi cambiare in «{{name}}»?",
    audio_voice_thinking: "Un momento, preparo il tuo audio …", audio_voice_preview: "Scrivo la tua anteprima …",
    audio_voice_type: "Nessun microfono — scrivi la tua risposta qui sotto.",
    audio_voice_tap: "Tocca il cerchio per continuare a parlare.",
    audio_voice_type_placeholder: "… oppure scrivi qui",
    audio_progress: "Audio {{done}} / {{total}} — prossimo: {{next}}",
    audio_progress_complete: "Audio completo — di' «fammelo sentire» o «salva»",
    audio_prepared_at: "Preparato oggi alle {{time}}", audio_no_voice: "Voce non disponibile ora — il testo è sotto l'icona documento.",
    audio_change_with_bro: "Modifica con Bro", audio_change_by_hand: "Modifica io", audio_delete: "Elimina",
  },
};

Object.keys(audioCardTranslations).forEach((lng) => {
  if (!resources[lng]) resources[lng] = { translation: {} };
  if (!resources[lng].translation) resources[lng].translation = {};
  Object.assign(resources[lng].translation, audioCardTranslations[lng]);
});

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "de",
    fallbackLng: "de",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
